<template>
  <div data-intro="Preencha ou edite os campos necessários." data-step="7">
    <div v-if="!!templateImages.length > 0 && !isMagazine">
      <label class="control-label" for="">
        Imagens
      </label>
      <div
          v-for="(image, index) in templateImages"
          class="row my-3"
          @mouseleave="unsetBorderToImageContent(image.index)"
          @mouseover="setBorderToImageContent(image.index)">

        <div v-if="!isMagazine" class="col-md-8 upload-btn-wrapper form-group">

          <button
              class="btn btn-outline-secondary btn-block h-100"
              type="button"
              @click="showCropImageModal(image.index)">
            Selecionar imagem
          </button>
        </div>

        <div :class="!isMagazine ? 'col-md-4' : 'col-md-12'" class="d-flex justify-content-center form-group">
          <label :for="`rotate-${image.index}`">Girar</label>
          <input
              :id="`rotate-${image.index}`"
              :name="`rotate-${image.index}`"
              class="form-control slider px-0"
              max="360"
              min="0"
              type="range"
              @input="rotateImage($event, image.index)">
        </div>

        <div v-if="false" class="col-md-12 md-mt-5 btn-group image-position-buttons">
          <button class="btn btn-sm btn-primary btn-block" type="button"
                  @click="alignImage(image.index, 'start center')">
            <i class="fa fa-long-arrow-up"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'start end')">
            <i class="fa fa-long-arrow-right top-right"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'center end')">
            <i class="fa fa-long-arrow-right"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'end end')">
            <i class="fa fa-long-arrow-right bottom-right"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'end center')">
            <i class="fa fa-long-arrow-down"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'end start')">
            <i class="fa fa-long-arrow-down bottom-left"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'center start')">
            <i class="fa fa-long-arrow-left"></i>
          </button>
          <button class="btn btn-sm btn-primary" type="button" @click="alignImage(image.index, 'start start')">
            <i class="fa fa-long-arrow-left top-left"></i>
          </button>
          <button class="btn btn-sm btn-primary btn-block" type="button"
                  @click="alignImage(image.index, 'center center', 'auto')">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>
    </div>

    <div v-show="inArray('free_value') && inTemplate('free_value')" class="form-group" key="freeValue">
      <label for="text">Preço livre</label>
      <input
          v-model.lazy="free_value"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_cash') || inArray('value_cash_inline')" class="form-group" key="valueCash">
      <label for="text">Preço</label>
      <input
          v-model.lazy="value_cash"
          v-money="decimal"
          :class="!isValidPriceMargin(value_cash) ? 'border-danger has-error' : ''"
          class="form-control mb-1"
          type="text"/>
      <span v-if="!isValidPriceMargin(value_cash)" class="text-danger mt- text-sm">
        Preço deve ser um valor entre {{ minPrice }} e {{ maxPrice }}
      </span>
      <span v-for="error in getMessageError('value_cash')" v-if="getMessageError('value_cash')"
            class="help-block has-error">
          <strong>{{ error }}</strong>
      </span>
    </div>

    <div v-show="inArray('value_cash2')" class="form-group" key="valueCash2">
      <label for="text">Preço à vista 2</label>
      <input
          v-model.lazy="value_cash2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_cash3')" class="form-group" key="valueCash3">
      <label for="text">
        Preço Regular 3
      </label>
      <input v-model.lazy="value_cash3" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('simple_description')" class="form-group" key="simpleDescription">
      <label for="text">
        Descrição 1
      </label>
      <textarea v-model="simple_description" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-show="inArray('simple_description2')" class="form-group" key="simpleDescription2">
      <label for="text">
        Descrição 2
      </label>
      <textarea v-model="simple_description2" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-show="inArray('simple_description3')" class="form-group" key="simpleDescription3">
      <label for="text">
        Descrição 3
      </label>
      <textarea v-model="simple_description3" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea></div>

    <div v-show="inArray('simple_description4')" class="form-group" key="simpleDescription4">
      <label for="text">
        Descrição 4
      </label>
      <input v-model="simple_description4" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('simple_description5')" class="form-group" key="simpleDescription5">
      <label for="text">
        Descrição 5
      </label>
      <input v-model="simple_description5" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('reoperated_product') && (inTemplate('reoperated_product') || inTemplate('PROD_REOPERADO'))"
         class="form-group" key="reoperatedProduct">
      <label for="text">
        Número Etiqueta Reoperado
      </label>
      <input v-model="reoperated_product" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('light_quantity')" class="form-group" key="lightQuantity">
      <label for="text">
        Quantidade Leve
      </label>
      <input v-model="light_quantity" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('retail_packaging')" class="form-group" key="retailPackaging">
      <label for="text">
        Embalagem de varejo
      </label>
      <input v-model="retail_packaging" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('wholesale_packing')" class="form-group" key="wholesalePacking">
      <label for="text">
        Embalagem de atacado
      </label>
      <input v-model="wholesale_packing" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('big_packing')" class="form-group" key="bigPacking">
      <label for="text">
        Embalagem grandes
      </label>
      <input v-model="big_packing" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('validation')" class="form-group" key="validation">
      <label for="text">
        Validação
      </label>
      <input v-model="validation" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('retail_taxation')" class="form-group" key="retailTaxation">
      <label for="text">
        Tributação de varejo
      </label>
      <input v-model="retail_taxation" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('wholesale_taxation')" class="form-group" key="wholesaleTaxation">
      <label for="text">
        Tributação de atacado
      </label>
      <input v-model="wholesale_taxation" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('big_taxation')" class="form-group" key="bigTaxation">
      <label for="text">
        Tributação grandes
      </label>
      <input v-model="big_taxation" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('light_taxation')" class="form-group" key="lightTaxation">
      <label for="text">
        Tributação leve
      </label>
      <input v-model="light_taxation" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('retail_media')" class="form-group" key="retailMedia">
      <label for="text">
        Média varejo
      </label>
      <input v-model="retail_media" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('wholesale_media')" class="form-group" key="wholesaleMedia">
      <label for="text">
        Média atacado
      </label>
      <input v-model="wholesale_media" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('big_media')" class="form-group" key="bigMedia">
      <label for="text">
        Média grandes
      </label>
      <input v-model="big_media" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('light_media')" class="form-group" key="lightMedia">
      <label for="text">
        Média leve
      </label>
      <input v-model="light_media" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('big_price')" class="form-group" key="bigPrice">
      <label for="text">
        Preço grandes
      </label>
      <input v-model="big_price" v-money="decimal" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-show="inArray('light_price')" class="form-group" key="lightPrice">
      <label for="text">
        Preço leve
      </label>
      <input v-model="light_price" v-money="decimal" class="form-control" maxlength="255" type="text"/>
    </div>

    <div
        v-show="(inArray('product_width') && (inTemplate('product_width') || inTemplate('LARGURA_PRODUTO') || inTemplate('LARG_PROD')))"
        class="form-group" key="productWidth">
      <label for="text">
        Largura do produto
      </label>
      <input v-model="product_width" class="form-control" maxlength="255" type="text"/>
    </div>

    <div
        v-show="(inArray('product_height') && (inTemplate('product_height') || inTemplate('ALTURA_PRODUTO') || inTemplate('ALT_PROD')))"
        class="form-group" key="productHeight">
      <label for="text">
        Altura do produto
      </label>
      <input v-model="product_height" class="form-control" maxlength="255" type="text"/>
    </div>

    <div
        v-show="(inArray('product_depth') && (inTemplate('product_depth') || inTemplate('PROFUNDIDADE_PRODUTO') || inTemplate('PROF_PROD')))"
        class="form-group" key="productDepth">
      <label for="text">
        Profundidade do produto
      </label>
      <input v-model="product_depth" class="form-control" maxlength="255" type="text"/>
    </div>

    <div
        v-show="(inArray('product_material') && (inTemplate('product_material') || inTemplate('MATERIAL_PRODUTO') || inTemplate('MAT_PROD')))"
        class="form-group" key="productMaterial">
      <label for="text">
        Material do produto
      </label>
      <input v-model="product_material" class="form-control" maxlength="255" type="text"/>
    </div>

    <div
        v-show="(inArray('product_evaluation') && (inTemplate('product_evaluation') || inTemplate('AVALIACAO_PRODUTO') || inTemplate('AVAL_PROD')))"
        class="form-group" key="productEvaluation">
      <label for="text">
        Avaliação do produto
      </label>
      <input v-model="product_evaluation" class="form-control" maxlength="255" type="text"/>
    </div>

    <div
        v-show="(inArray('product_comments') && (inTemplate('product_comments') || inTemplate('COMENTARIOS_PRODUTO') || inTemplate('COMENT_PROD')))"
        class="form-group" key="productComments">
      <label for="text">
        Comentários do produto
      </label>
      <input v-model="product_comments" class="form-control" maxlength="255" type="text"/>
    </div>

    <div v-if="inArray('product_other_colors')"
         v-show="((inTemplate('product_other_colors') || inTemplate('OUTRAS_CORES_PRODUTO') || inTemplate('OUT_COR_PROD')))"
         class="form-group" key="productOtherColors">
      <label for="text">
        Outras cores do produto
      </label>
      <textarea v-model="product_other_colors" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-if="inArray('product_other_sizes')"
         v-show="((inTemplate('product_other_sizes') || inTemplate('OUTROS_CORES_TAMANHOS') || inTemplate('OUT_TAM_PROD')))"
         class="form-group" key="productOtherSizes">
      <label for="text">
        Outros tamanhos do produto
      </label>
      <textarea v-model="product_other_sizes" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-if="inArray('unit_proportional')"
         v-show="(inTemplate('unit_proportional') || inTemplate('UNIT_PROPORTIONAL'))"
         class="form-group" key="unitProportional">
      <label for="text">
        Unidade de venda proporcional
      </label>
      <textarea v-model="unit_proportional" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-if="inArray('free_text')"
         v-show="(inTemplate('free_text') || inTemplate('TEXTO_LIVRE1') || inTemplate('FTXT_1'))"
         class="form-group" key="freeText">
      <label for="text">
        Texto Livre 1
      </label>
      <textarea v-model="free_text" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-if="inArray('free_text2')"
         v-show="(inTemplate('free_text2') || inTemplate('TEXTO_LIVRE2') || inTemplate('FTXT_2'))"
         class="form-group" key="freeText2">
      <label for="text">
        Texto Livre 2
      </label>
      <textarea v-model="free_text2" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-if="inArray('free_text3')"
         v-show="(inTemplate('free_text3') || inTemplate('TEXTO_LIVRE3') || inTemplate('FTXT_3'))"
         class="form-group" key="freeText3">
      <label for="text">
        Texto Livre 3
      </label>
      <textarea v-model="free_text3" class="form-control" maxlength="255" rows="2"
                style="resize: none;"></textarea>
    </div>

    <div v-show="inArray('discount_bundle')" class="form-group" key="discountBundle">
      <label for="text">
        Desconto Combo
      </label>
      <input v-model.lazy="discount_bundle" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('value_bundle')" class="form-group" key="valueBundle">
      <label for="text">
        Preço Combo
      </label>
      <input v-model.lazy="value_bundle" v-money="decimal" class="form-control" readonly type="text"/>
    </div>

    <div v-show="inArray('value_wholesale')" class="form-group" key="valueWholesale">
      <label for="text">
        Preço no Atacado
      </label>
      <input v-model="value_wholesale" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('value_wholesale_card')" class="form-group" key="valueWholesaleCard">
      <label for="text">
        Dual Price
      </label>
      <input v-model="value_wholesale_card" v-money="decimal" class="form-control" disabled type="text"/>
    </div>

    <div v-show="inArray('discount')" class="form-group" key="discount">
      <label for="text">Desconto</label>
      <input
          v-model.lazy="discount"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('unitary_value')" class="form-group" key="unitaryValue">
      <label for="text">Preço Unitário</label>
      <input
          v-model.lazy="unitary_value"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('value_in_cash')" v-show="inTemplate('value_in_cash') || inTemplate('VAL_VISTA')"
         class="form-group" key="valueInCash">
      <label for="text">Preço À Vista</label>
      <input
          v-model.lazy="value_in_cash"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('discount_fastshop')" class="form-group" key="discount_fastshop">
      <label for="text">Desconto Fastshop</label>
      <input
          v-model.lazy="discount_fastshop"
          v-money="decimal"
          class="form-control"
          :disabled="true"
          type="text"/>
    </div>

    <div v-if="inArray('exclusive_value_cash')"
         v-show="(inTemplate('exclusive_value_cash') || inTemplate('EXC_VAL_A_VISTA'))"
         class="form-group" key="exclusiveValueCash">
      <label for="text">Preço Exclusivo</label>
      <input
          v-model="exclusive_value_cash"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('exclusive_value_cash_2')"
         v-show="(inTemplate('exclusive_value_cash_2') || inTemplate('EXC_VAL_A_VISTA_2'))"
         class="form-group" key="exclusiveValueCash2">
      <label for="text">Preço Exclusivo 2</label>
      <input
          v-model="exclusive_value_cash_2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('exclusive_value_in_cash')"
         v-show="inTemplate('exclusive_value_in_cash') || inTemplate('EXC_VAL_VISTA')"
         class="form-group" key="exclusiveValueInCash">
      <label for="text">Preço À Vista Exclusivo</label>
      <input
          v-model="exclusive_value_in_cash"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('exclusive_value_in_cash_2')"
         v-show="inTemplate('exclusive_value_in_cash_2') || inTemplate('EXC_VAL_VISTA_2')"
         class="form-group" key="exclusiveValueInCash2">
      <label for="text">Preço À Vista Exclusivo 2</label>
      <input
          v-model="exclusive_value_in_cash_2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('cashback_value')"
         v-show="(inTemplate('cashback_value') || inTemplate('CASHBACK_VAL'))"
         class="form-group" key="cashbackValue">
      <label for="text">Dinheiro de volta</label>
      <input
          v-model.lazy="cashback_value"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('cashback_value_2')"
         v-show="(inTemplate('cashback_value_2') || inTemplate('CASHBACK_VAL_2'))"
         class="form-group" key="cashbackValue2">
      <label for="text">Dinheiro de volta 2</label>
      <input
          v-model.lazy="cashback_value_2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('total_value')" class="form-group" key="totalValue">
      <label for="text">Valor total</label>
      <input
          v-model.lazy="total_value"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('value_old') || inArray('value_old_inline')"
         v-show="inTemplate('value_old') || inTemplate('VAL_PROM')"
         :class="hasError('value_old') ? 'has-error' : ''"
         class="form-group" key="valueOld">
      <label for="text">Preço Promocional</label>
      <input
          v-model.lazy="value_old"
          v-money="decimal"
          :class="!isValidPriceMargin(value_old) ? 'border-danger has-error' : ''"
          :disabled="checkIsInPoster('reduced_value') && isMagazine"
          class="form-control mb-1"
          type="text"/>
      <span v-if="!isValidPriceMargin(value_old)" class="text-danger mt- text-sm">
        Preço deve ser um valor entre {{ minPrice }} e {{ maxPrice }}
      </span>

      <span v-for="error in getMessageError('value_old')" v-if="getMessageError('value_old')"
            class="help-block has-error">
          <strong>{{ error }}</strong>
      </span>
    </div>

    <div v-if="inArray('value_old2')" v-show="inTemplate('value_old2')" class="form-group" key="valueOld2">
      <label for="text">Preço Promocional 2</label>
      <input
          v-model.lazy="value_old2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('value_old3')" v-show="inTemplate('value_old3')" class="form-group" key="valueOld3">
      <label for="text">Preço Promocional 3</label>
      <input
          v-model.lazy="value_old3"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('quantity')" class="form-group" key="quantity">
      <label for="text">Quantidade</label>
      <input v-model="quantity" v-money="integer" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('quantity_fractional')" class="form-group" key="quantity_fractional">
      <label for="text">Quantidade Fracionada</label>
      <input v-model="quantity_fractional" class="form-control" type="number" step="0.01"/>
    </div>

    <div v-if="inArray('reduced_value') && checkIsInPoster('reduced_value')" class="form-group" key="reducedValue">
      <label for="text">
        Preço reduzido
      </label>
      <input v-model.lazy="reduced_value" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('quantity2')" class="form-group" key="quantity2">
      <label for="text">Quantidade 2</label>
      <input
          v-model="quantity2"
          v-money="integer"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('quantity3')" class="form-group" key="quantity3">
      <label for="text">
        Quantidade 3
      </label>
      <input v-model="quantity3" v-money="integer" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('quantity4')" class="form-group" key="quantity4">
      <label for="text">
        Quantidade 4
      </label>
      <input v-model="quantity4" v-money="integer" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('quantity5')" class="form-group" key="quantity5">
      <label for="text">
        Quantidade 5
      </label>
      <input v-model="quantity5" v-money="integer" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('promotion_product')" class="form-group" key="promotionProduct">
      <label for="text">
        Produto Promocional
      </label>
      <v-select v-model="productPromotionalSelected" :options="listOfProducts"
                label="code" @search="fetchPromotionalProducts"></v-select>
    </div>

    <div v-show="inArray('promotional_product_value')" class="form-group" key="promotionalProductValue">
      <label for="text">
        Preço do Produto Promocional
      </label>
      <input v-model="promotional_product_value" v-money="decimal" class="form-control" type="text"/>
    </div>


    <div v-show="inArray('promotion_description') && inTemplate('promotion_description')"
         class="form-group" key="promotionDescription">
      <label for="text">Descrição Promocional</label>
      <input
          v-model="promotion_description"
          class="form-control"
          maxlength="255"
          type="text"
          v-on:focus="clearField('promotion_description')"/>
    </div>

    <div v-show="inArray('promotion_main_description') && inTemplate('promotion_main_description')"
         class="form-group" key="promotionMainDescription">
      <label for="text">Descrição Principal Promocional</label>
      <input
          v-model="promotion_main_description"
          class="form-control"
          maxlength="255"
          type="text"
          v-on:focus="clearField('promotion_main_description')"/>
    </div>

    <div v-show="inArray('promotion_minor_description') && inTemplate('promotion_minor_description')"
         class="form-group" key="promotionMinorDescription">
      <label for="text">Descrição Secundária Promocional</label>
      <input
          v-model="promotion_minor_description"
          class="form-control"
          maxlength="255"
          type="text"
          v-on:focus="clearField('promotion_minor_description')"/>
    </div>

    <div v-show="inArray('promotion_unit')" class="form-group" key="promotionUnit">
      <label for="text">Unidade de Venda Promocional</label>
      <input
          v-model="promotionUnitSelected"
          class="form-control"
          type="text"
          v-on:focus="clearField('promotion_unit')"/>
    </div>

    <div v-show="inArray('promotion_unit2')" class="form-group" key="promotionUnit2">
      <label for="text">Unidade de Venda Promocional 2</label>
      <select
          id="selectPromotionUnit"
          v-model="promotionUnit2Selected"
          class="form-control select2">
        <option v-for="unit in listOfUnits" v-bind:value="unit">
          {{ unit.name }}
        </option>
      </select>
    </div>

    <div v-show="inArray('sales_unit_wholesale')" class="form-group" key="salesUnitWholesale">
      <label for="text">Unidade de Venda no Atacado</label>
      <input
          v-model="sales_unit_wholesale"
          class="form-control"
          type="text"
          v-on:focus="clearField('sales_unit_wholesale')"/>
    </div>

    <div v-show="inArray('value_total_wholesale')" class="form-group" key="valueTotalWholesale">
      <label for="text">Preço Total no Atacado</label>
      <input
          v-model="value_total_wholesale"
          v-money="decimal"
          class="form-control"
          readonly
          type="text"/>
    </div>

    <div v-show="inArray('value_retail')" class="form-group" key="valueRetail">
      <label for="text">
        Preço no Varejo
      </label>
      <input v-model="value_retail" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('value_wholeretail')" class="form-group" key="valueWholeretail">
      <label for="text">
        Preço no atacarejo
      </label>
      <input v-model="value_wholeretail" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('value_wholeretail_2')" class="form-group" key="valueWholeretail2">
      <label for="text">
        Preço no atacarejo 2
      </label>
      <input v-model="value_wholeretail_2" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('value_wholeretail_3')" class="form-group" key="valueWholeretail3">
      <label for="text">
        Preço no atacarejo 3
      </label>
      <input v-model="value_wholeretail_3" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('value_wholeretail_4')" class="form-group" key="valueWholeretail4">
      <label for="text">
        Preço no atacarejo 4
      </label>
      <input v-model="value_wholeretail_4" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div class="form-group" v-show="inArray('base_value') || inTemplate('PRECO_BASE')"
         key="baseValue">
      <label for="text">Preço Base</label>
      <input
          type="text"
          v-model.lazy="base_value"
          v-money="decimal"
          class="form-control"/>
    </div>

    <div class="form-group" v-show="inArray('base_total_value') || inTemplate('PRECO_BASE_TOTAL')"
         key="baseTotalValue">
      <label for="text">Preço Base Total</label>
      <input
          type="text"
          v-model.lazy="base_total_value"
          v-money="decimal"
          class="form-control"/>
    </div>

    <div v-show="inArray('base_parcel_quantity') || inTemplate('QUANTIDADE_DE_PARCELAS_BASE')" class="form-group"
         key="baseParcelQuantity">
      <label for="text">Quantidade de Parcelas Base</label>
      <input
          v-model.lazy="base_parcel_quantity"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div class="form-group" v-show="inArray('base_parcel_value') || inTemplate('VALOR_DA_PARCELA_BASE')"
         key="baseParcelValue">
      <label for="text">Valor da Parcela Base</label>
      <input
          type="text"
          v-model.lazy="base_parcel_value"
          v-money="decimal"
          class="form-control"/>
    </div>

    <div v-show="inArray('derived_code') || inTemplate('CODIGO_DERIVADO')" class="form-group"
         key="derivedCode">
      <label for="text">Código Derivado</label>
      <input
          v-model.lazy="derived_code"
          v-money="integer"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('warranty') || inTemplate('WARRANTY')" class="form-group"
         key="warranty">
      <div class="am-checkbox">
        <input id="warranty" v-model="hasWarranty" type="checkbox"/>
        <label for="warranty">Garantia</label>
      </div>
    </div>

    <div v-show="inArray('assembly') || inTemplate('ASSEMBLY')" class="form-group"
         key="assembly">
      <div class="am-checkbox">
        <input id="assembly" v-model="hasAssembly" type="checkbox"/>
        <label for="assembly">Montagem</label>
      </div>
    </div>

    <div v-show="inArray('about_product') || inTemplate('ABOUT_PRODUCT')" class="form-group"
         key="aboutProduct">
      <label for="text">Sobre o produto</label>
      <textarea
          class="form-control"
          :maxlength="255"
          rows="2"
          style="resize: none;"
          v-on:focus="clearField('about_product')"
          v-model="about_product"></textarea>
    </div>

    <div v-show="inArray('supported_weight') || inTemplate('SUPPORTED_WEIGHT')" class="form-group"
         key="supportedWeight">
      <label for="text">Peso suportado</label>
      <input
          v-model="supported_weight"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_wholeretail_5')" class="form-group" key="valueWholeretail5">
      <label for="text">
        Preço no atacarejo 5
      </label>
      <input v-model="value_wholeretail_5" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-if="inArray('proportional_measure')" v-show="showFields"
         :class="hasError('proportional_measure') ? 'has-error' : ''"
         class="form-group" key="paymentType">
      <label for="selectProportionalMeasure">Medida Proporcional</label>
      <select
          id="selectProportionalMeasure"
          v-model="proportional_measure"
          class="form-control select2">
        <option v-for="proportionalMeasure in listOfProportionalMeasures">
          {{ proportionalMeasure }}
        </option>
      </select>

      <span v-for="error in getMessageError('proportional_measure')" v-if="getMessageError('proportional_measure')"
            class="help-block has-error">
          <strong>{{ error }}</strong>
      </span>
    </div>

    <div v-show="inArray('proportional_quantity') || inTemplate('PROPORTIONAL_QUANTITY')" class="form-group"
         key="proportional_quantity">
      <label for="text">
        Quantidade Proporcional
      </label>
      <input v-model="proportional_quantity" v-money="integer" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('product_proportional_value') || inTemplate('PRODUCT_PROPORTIONAL_VALUE')" class="form-group"
         key="productProportionalValue">
      <label for="text">
        Preço proporcional Produto
      </label>
      <input v-model="product_proportional_value" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div v-show="inArray('proportional_value')" class="form-group" key="proportionalValue">
      <label for="text">
        Preço proporcional
      </label>
      <input v-model="proportional_value" v-money="decimal" class="form-control" type="text"/>
    </div>

    <div
        v-show="inArray('parceled_interest') || inArray('parceled_interest_inline')"
        class="form-group" key="parceledInterest">
      <label for="text">Número de Parcelas com Juros</label>
      <input
          v-model.lazy="parceled_interest"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div
        v-show="inArray('parceled_interest_2') || inTemplate('parceled_interest_2')"
        class="form-group" key="parceledInterest2">
      <label for="text">Número de Parcelas com Juros 2</label>
      <input
          v-model.lazy="parceled_interest_2"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div v-show="inArray('parceled') || inArray('parceled_inline')" class="form-group" key="parcel">
      <label for="text">Número de Parcelas</label>
      <input
          v-model.lazy="parcel"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div v-show="inArray('parcel_separated_2')" class="form-group" key="parcel_separated_2">
      <label for="text">Número de Parcelas Manual 2</label>
      <input
          v-model.lazy="parcel_separated_2"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div v-show="inArray('exclusive_parcel') && (inTemplate('exclusive_parcel') || inTemplate('EXC_PARCELADO'))"
         class="form-group" key="exclusiveParcel">
      <label for="text">Número de Parcelas exclusivas</label>
      <input
          v-model.lazy="exclusive_parcel"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div v-show="inArray('exclusive_parcel_2') && (inTemplate('exclusive_parcel_2') || inTemplate('EXC_PARCELADO_2'))"
         class="form-group" key="exclusiveParcel2">
      <label for="text">Número de Parcelas exclusivas 2</label>
      <input
          v-model.lazy="exclusive_parcel_2"
          v-money="integer"
          class="form-control"
          maxlength="3"
          type="text"/>
    </div>

    <div v-show="inArray('has_interest') && !subDomain == 'magazineluiza'" class="form-group" key="showFields">
      <div class="am-checkbox">
        <input id="rateFields" v-model="showFields" type="checkbox"/>
        <label for="rateFields">Utilizar Planilha de Financiamento</label>
      </div>
    </div>

    <div v-if="inArray('payment_type')" v-show="showFields" :class="hasError('payment_type') ? 'has-error' : ''"
         class="form-group" key="paymentType">
      <label for="selectPaymentType">Formas de Pagamento</label>
      <select
          id="selectPaymentType"
          v-model="payment_type"
          class="form-control select2">
        <option v-for="type in listOfPaymentTypes" v-bind:value="type.sheet_name">
          {{ type.sheet_name }}
        </option>
      </select>

      <span v-for="error in getMessageError('payment_type')" v-if="getMessageError('payment_type')"
            class="help-block has-error">
          <strong>{{ error }}</strong>
      </span>
    </div>

    <div v-if="inArray('payment_type') && subDomain == 'magazineluiza' && inArray('inputs')"
         v-show="showFields && !inArray('value_plot') && inArray('inputs')"
         class="form-group" key="inputsMagazineLuiza">
      <div class="am-radio inline" data-checkbox="is_not_specific_account">
        <input
            id="inputs"
            v-model="inputs"
            :class="!!inputs ? 'active' : ''"
            name="inputs"
            type="radio"
            value="1+">
        <label for='inputs'>
          Com entrada
        </label>
      </div>
      <div class="am-radio inline" data-checkbox="is_specific_account">
        <input
            id="is_not_inputs"
            v-model="inputs"
            :class="!!inputs ? 'active' : ''"
            name="inputs"
            type="radio"
            value="">
        <label for='is_not_inputs'>
          Sem entrada
        </label>
      </div>
    </div>

    <div
        v-show="inArray('exclusive_value_plot') && (inTemplate('exclusive_value_plot') || inTemplate('EXC_VAL_PARC') || inTemplate('EXC_VALOR_PARCELA') || inTemplate('EXC_VP'))"
        class="form-group" key="exclusiveValuePlot">
      <label for="text">Valor da Parcela</label>
      <input
          v-model.lazy="exclusive_value_plot"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div
        v-show="inArray('exclusive_value_plot_2') && (inTemplate('exclusive_value_plot_2') || inTemplate('EXC_VAL_PARC_2') || inTemplate('EXC_VALOR_PARCELA_2') || inTemplate('EXC_VP_2'))"
        class="form-group" key="exclusiveValuePlot2">
      <label for="text">Valor da Parcela 2</label>
      <input
          v-model.lazy="exclusive_value_plot_2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div
        v-show="inArray('value_plot_separated') || inArray('value_plot_separated_inline')"
        class="form-group" key="valuePlotSeparated">
      <label for="text">Valor da Parcela</label>
      <input
          v-model.lazy="value_plot_separated"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div
        v-show="inArray('value_plot_separated_2')"
        class="form-group" key="valuePlotSeparated2">
      <label for="text">Valor da Parcela 2</label>
      <input
          v-model.lazy="value_plot_separated_2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div
        v-show="inArray('value_plot_interest') || inArray('value_plot_interest_inline')"
        class="form-group" key="valuePlotInterest">
      <label for="text">Valor da Parcela com Juros</label>
      <input
          v-model.lazy="value_plot_interest"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div
        v-show="inArray('value_plot_interest_2') || inTemplate('value_plot_interest_2')"
        class="form-group" key="valuePlotInterest2">
      <label for="text">Valor da Parcela com Juros 2</label>
      <input
          v-model.lazy="value_plot_interest_2"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('cet')" v-show="showFields" class="form-group" key="cet">
      <label for="text">Taxa CET</label>
      <input
          v-model.lazy="cet"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('cet_py')" v-show="showFields" class="form-group" key="cetPy">
      <label for="text">Taxa CET ao ano</label>
      <input
          v-model.lazy="cet_py"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-if="inArray('has_interest')" v-show="showFields" :class="hasError('has_interest') ? 'has-error' : ''"
         class="form-group" key="hasInterest">
      <label for="text">Taxa de Juros</label>
      <input
          v-model="has_interest"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>

      <span v-for="error in getMessageError('has_interest')" v-if="getMessageError('has_interest')"
            class="help-block has-error">
          <strong>{{ error }}</strong>
      </span>
    </div>

    <div
        v-if="inArray('has_interest') && showFactorField"
        v-show="showFields" class="form-group" key="factor">
      <label for="text">Índice</label>
      <input
          v-model="factor"
          v-money="factorMask"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('rates_info')" class="form-group" key="ratesInfo">
      <label for="text">Informações Sobre Taxas</label>
      <input
          v-model="rates_info"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('total_term')" :class="hasError('total_term') ? 'has-error' : ''"
         class="form-group" key="totalTerm">
      <label for="text">Total a Prazo</label>
      <input
          v-model.lazy="total_term"
          v-money="decimal"
          class="form-control mb-1"
          type="text"/>

      <span v-for="error in getMessageError('total_term')" v-if="getMessageError('total_term')"
            class="help-block has-error">
          <strong>{{ error }}</strong>
      </span>
    </div>

    <div v-show="inArray('total_term_2') || inTemplate('total_term_2')" class="form-group" key="totalTerm2">
      <label for="text">Total a Prazo 2</label>
      <input
          v-model.lazy="total_term_2"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_plot')" class="form-group" key="valuePlot">
      <label for="text">Valor da Parcela</label>
      <input
          v-model.lazy="value_plot"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_divided')" class="form-group" key="valueDivided">
      <label for="text">Divisão dos Valores</label>
      <input
          v-model.lazy="value_divided"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_sum')" class="form-group" key="valueSum">
      <label for="text">Soma dos Valores</label>
      <input
          v-model.lazy="value_sum"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('spare') || inArray('spare_inline')" class="form-group" key="spare">
      <label for="text">Economize</label>
      <input
          v-model.lazy="spare"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('spared_percent') || inArray('spared_percent_inline')"
         class="form-group" key="sparedPercent">
      <label for="text">Percentual Economizado</label>
      <input
          v-model.lazy="spared_percent"
          v-money="decimal"
          :readonly="!isHybrid"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('value_remaining')" class="form-group" key="valueRemaining">
      <label for="text">Valor Restante</label>
      <input
          v-model.lazy="value_remaining"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('parcel_paid')" class="form-group" key="parcelPaid">
      <label for="text">Parcela Paga</label>
      <input
          v-model.lazy="parcel_paid"
          v-money="integer"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('inputs') && subDomain !== 'magazineluiza'" class="form-group" key="inputs">
      <div class="am-radio inline" data-checkbox="is_not_specific_account">
        <input
            id="inputs"
            v-model="inputs"
            name="inputs"
            type="radio"
            value="1">
        <label for='inputs'>
          Com entrada
        </label>
      </div>
      <div class="am-radio inline" data-checkbox="is_specific_account">
        <input
            id="is_not_inputs"
            v-model="inputs"
            name="inputs"
            type="radio"
            value="0">
        <label for='is_not_inputs'>
          Sem entrada
        </label>
      </div>
    </div>

    <div
        v-if="(inArray('product_older') && (inTemplate('product_older') || inTemplate('PRD_18') || inTemplate('PRODUTO_18') ))"
        class="row" key="insertProductOlder">
      <div class="col-12">
        <div class="am-checkbox"
             data-intro="Clique no quadrado caso o produto seja para maiores de 18."
             data-step="8">

          <input id="insertProductOlder" v-model="insertProductOlder" type="checkbox"/>

          <label for="insertProductOlder" style="font-size: 12px;">
            Produto para maiores de 18
          </label>
        </div>
      </div>
    </div>

    <div v-if="showProductOlder"
         class="col-12"
         data-intro="Clique para digitar a descrição +18."
         data-position="top"
         data-step="9">
      <div
          v-if="(inArray('product_older') && (inTemplate('product_older') || inTemplate('PRD_18') || inTemplate('PRODUTO_18') ))"
          class="form-group" key="productOlder">
        <input v-model="product_older" class="form-control" type="text"/>

      </div>
    </div>

    <div class="form-group"
         v-show="inArray('from_wholesale') && (inTemplate('from_wholesale') || inTemplate('FROM_WHOLESALE'))">
      <label for="text">
        A Partir Atacado
      </label>
      <input type="text" v-model="from_wholesale" maxlength="255" class="form-control"/>
    </div>

    <div class="form-group" v-show="inArray('from_large') && (inTemplate('from_large') || inTemplate('FROM_LARGE'))">
      <label for="text">
        A Partir Grandes
      </label>
      <input type="text" v-model="from_large" maxlength="255" class="form-control"/>
    </div>

    <div v-show="inArray('percentage_app') && (inTemplate('percentage_app') || inTemplate('PARCELA_APP'))"
         class="form-group" key="percentageApp">
      <label for="text">Percentual App</label>
      <input
          v-model.lazy="percentage_app"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('price_app') && (inTemplate('price_app') || inTemplate('PRECO_APP'))"
        class="form-group" key="priceApp">
      <label for="text">Preço App</label>
      <input
          v-model.lazy="price_app"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('limit_app') && (inTemplate('limit_app') || inTemplate('LIMITE_APP'))"
         class="form-group" key="limitApp">
      <label for="text">Limite App</label>
      <textarea
          class="form-control"
          :maxlength="255"
          rows="2"
          style="resize: none;"
          v-on:focus="clearField('limit_app')"
          v-model="limit_app"></textarea>
    </div>

    <div v-show="inArray('percentage_card') && (inTemplate('percentage_card') || inTemplate('PORCENTUAL_CARTAO'))"
         class="form-group" key="percentageCard">
      <label for="text">Percentual Cartão</label>
      <textarea
          class="form-control"
          :maxlength="255"
          rows="2"
          style="resize: none;"
          v-on:focus="clearField('percentage_card')"
          v-model="percentage_card"></textarea>
    </div>

    <div v-show="inArray('price_card') && (inTemplate('price_card') || inTemplate('PRECO_CARTAO'))"
         class="form-group" key="priceCard">
      <label for="text">Preço Cartão</label>
      <input
          v-model.lazy="price_card"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('limit_card') && (inTemplate('limit_card') || inTemplate('LIMITE_CARTAO'))"
         class="form-group" key="limitCard">
      <label for="text">Limite Cartão</label>
      <textarea
          class="form-control"
          :maxlength="255"
          rows="2"
          style="resize: none;"
          v-on:focus="clearField('limit_card')"
          v-model="limit_card"></textarea>
    </div>

    <div v-show="inArray('parcel_number_card') && (inTemplate('parcel_number_card') || inTemplate('NUMERO_PARCELAS_CARTAO'))"
         class="form-group" key="parcelNumberCard">
      <label for="text">Número Parcelas Cartão</label>
      <input
          v-model.lazy="parcel_number_card"
          v-money="integer"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('parcel_price_card') && (inTemplate('parcel_price_card') || inTemplate('PRECO_PARCELADO_CARTAO'))"
         class="form-group" key="parcelPriceCard">
      <label for="text">Preço Parcelado Cartão</label>
      <input
          v-model.lazy="parcel_price_card"
          v-money="decimal"
          class="form-control"
          type="text"/>
    </div>

    <div v-show="inArray('minimum_app') && (inTemplate('minimum_app') || inTemplate('MINIMO_APP'))"
         class="form-group" key="minimumApp">
      <label for="text">Mínimo App</label>
      <textarea
          class="form-control"
          :maxlength="255"
          rows="2"
          style="resize: none;"
          v-on:focus="clearField('minimum_app')"
          v-model="minimum_app"></textarea>
    </div>

    <div v-if="(inArray('validate') && (inTemplate('validate') || inTemplate('VALIDADE') || inTemplate('VLD_UNICA') ))"
         class="row" key="insertProductExpirationDates">
      <div class="col-12">
        <div
            class="am-checkbox"
            data-intro="Clique no quadrado caso o produto tenha uma data de validade."
            data-step="8">
          <input
              id="insertProductExpirationDates"
              v-model="insertProductExpirationDates"
              type="checkbox"/>
          <label for="insertProductExpirationDates" style="font-size: 12px;">
            Incluir data de validade do produto
          </label>
        </div>
      </div>
    </div>

    <div v-if="showProductDate"
         class="col-12"
         data-intro="Clique para selecionar data de início da oferta."
         data-position="top"
         data-step="9">
      <div
          v-if="(inArray('validate') && (inTemplate('validate') || inTemplate('VALIDADE') || inTemplate('VLD_UNICA') ))"
          class="form-group" key="validate">
        <label for="text">Validade do produto</label>
        <datepicker
            v-model="validate"
            :format="'dd/MM/yyyy'"
            :language="datepickerLang"
            input-class="form-control keep-active">
        </datepicker>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12">
        <div
            class="am-checkbox"
            data-intro="Clique no quadrado caso a oferta tenha uma data de validade."
            data-step="8"
            key="insertExpirationDates">
          <input
              id="insertExpirationDates"
              v-model="insertExpirationDates"
              type="checkbox"/>
          <label for="insertExpirationDates">
            Incluir data de validade
          </label>
        </div>
      </div>
      <div
          v-if="showDate"
          class="col-xs-12 col-sm-6"
          data-intro="Clique para selecionar data de início da oferta."
          data-position="top"
          data-step="9">
        <div
            v-if="(inArray('valid_from') || inArray('valid_date_inline')) && showDate"
            :class="hasError('valid_from') ? 'has-error' : ''"
            class="form-group" key="validFrom">
          <label for="text">Válido de</label>
          <datepicker
              v-model="valid_from"
              :format="'dd/MM/yyyy'"
              :language="datepickerLang"
              input-class="form-control keep-active">
          </datepicker>
        </div>
        <span v-for="error in getMessageError('valid_from')" v-if="getMessageError('valid_from')"
              class="help-block has-error">
          <strong>{{ error }}</strong>
        </span>
      </div>

      <div
          v-if="showDate"
          class="col-xs-12 col-sm-6"
          data-intro="Selecione a data de término da oferta."
          data-position="top"
          data-step="10">
        <div
            v-if="(inArray('valid_until') || inArray('valid_date_inline')) && showDate"
            :class="hasError('valid_until') ? 'has-error' : ''"
            class="form-group" key="validUntil">
          <label for="text">Válido até</label>
          <datepicker
              v-model="valid_until"
              :format="'dd/MM/yyyy'"
              :language="datepickerLang"
              input-class="form-control keep-active">
          </datepicker>
        </div>
        <span v-for="error in getMessageError('valid_until')" v-if="getMessageError('valid_until')"
              class="help-block has-error">
          <strong>{{ error }}</strong>
        </span>
      </div>
    </div>

    <div v-if="inArray('custom_qr_code') && inTemplate('custom_qr_code') && !isMagazine" key="insertCustomQrcode">
      <div class="row">
        <div class="col-12">
          <div class="am-checkbox"
               data-intro="Clique no quadrado caso o cartaz possua QR Code personalizado."
               data-step="8">
            <input id="insert_custom_qrcode" v-model="insert_custom_qrcode" type="checkbox"/>
            <label for="insert_custom_qrcode">Incluir QR CODE personalizado</label>
          </div>
        </div>
      </div>
    </div>

    <div v-if="inArray('value_cash_tag') && (inTemplate('value_cash_tag') || inTemplate('VAL_A_VISTA_ETIQUETA'))"
         key="value_cash_tag">
      <div class="row">
        <div class="col-12">
          <div class="am-checkbox"
               data-intro="Clique no quadrado caso o cartaz possua Preço Etiqueta."
               data-step="8">
            <input id="insert_value_cash_tag" v-model="insert_value_cash_tag" type="checkbox"/>
            <label for="insert_value_cash_tag">Incluir Preço Etiqueta</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="insert_value_cash_tag"
             class="col-xs-12 col-sm-12"
             data-intro="Clique para inserir a url do QR Code."
             data-position="top"
             data-step="9">
          <div class="form-group">

            <label for="text">Preço Etiqueta</label>
            <input
                v-model.lazy="value_cash_tag"
                v-money="decimal"
                :class="!isValidPriceMargin(value_cash_tag) ? 'border-danger has-error' : ''"
                class="form-control mb-1"
                type="text"/>
            <span v-if="!isValidPriceMargin(value_cash_tag)" class="text-danger mt- text-sm">
                Preço deve ser um valor entre {{ minPrice }} e {{ maxPrice }}
            </span>
            <span v-for="error in getMessageError('value_cash_tag')" v-if="getMessageError('value_cash_tag')"
                  class="help-block has-error">
                <strong>{{ error }}</strong>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="inArray('qr_code') && inTemplate('qr_code')" key="qrCode">
      <div class="row">
        <div class="col-12">
          <div class="am-checkbox"
               data-intro="Clique no quadrado caso o cartaz possua QR Code."
               data-step="8">
            <input id="insert_qrcode" v-model="insert_qrcode" type="checkbox"/>
            <label for="insert_qrcode">Incluir QR CODE</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="insert_qrcode"
             class="col-xs-12 col-sm-12"
             data-intro="Clique para inserir a url do QR Code."
             data-position="top"
             data-step="9">
          <div class="form-group">
            <label for="qrcode">Url do QR CODE</label>
            <input id="qrcode" v-model="qr_code" class="form-control" type="text"/>
          </div>
        </div>
      </div>
    </div>

    <div v-if="inArray('bar_code') && inTemplate('bar_code')" key="barCode">
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="am-checkbox"
               data-intro="Clique no quadrado caso o cartaz possua código de barras."
               data-step="8">
            <input id="insertBarcode" v-model="insertBarcode" type="checkbox"/>
            <label for="insertBarcode">Incluir código de barras</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="insertBarcode"
             class="col-xs-12 col-sm-12"
             data-intro="Clique para inserir a url do código de barras."
             data-position="top"
             data-step="9">
          <div class="form-group">
            <label for="urlbarcode">Url do código de barras</label>
            <input id="urlbarcode" v-model="bar_code" class="form-control" type="text"/>
          </div>
        </div>
      </div>
    </div>

    <div v-show="inArray('ibm_code') && inTemplate('ibm_code')"
         class="form-group" key="ibmCode">
      <label for="text">Código IBM</label>
      <input
          v-model="ibm_code"
          class="form-control"
          maxlength="255"
          type="text"
          v-on:focus="clearField('ibm_code')"/>
    </div>

    <div v-if="inArray('offer_information') && inTemplate('offer_information')" key="offerInformation">
      <div class="row">
        <div class="col-12">
          <div class="am-checkbox"
               data-intro="Clique no quadrado caso o cartaz possua Informativo de Oferta."
               data-step="8">
            <input id="insertOfferInformation" v-model="insert_offer_information" type="checkbox"/>
            <label for="insertOfferInformation">Incluir informativo da oferta</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="insert_offer_information"
             class="col-xs-12 col-sm-12"
             data-intro="Clique para inserir o informativo da oferta."
             data-position="top"
             data-step="9">
          <div class="form-group">
            <label for="offerInformation">Informativo da Oferta</label>
            <input id="offerInformation" v-model="offer_information" class="form-control" type="text"/>
          </div>
        </div>
      </div>
    </div>
    <crop-image-modal></crop-image-modal>
  </div>
</template>

<script>
import {VMoney} from 'v-money';
import RateService from './services/rate_service';
import ProductService from './services/product_service';
import vSelect from 'vue-select';
import {ptBR} from 'vuejs-datepicker/dist/locale';
import CropImageModal from '@/components/CropImageModal.vue';
import dayjs from 'dayjs';

export default {
  directives: {
    money: VMoney,
  },
  components: {
    vSelect, CropImageModal,
  },
  props: {
    isPosterLoaded: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    subDomain: String,
    isMagazine: Boolean,
    onlineAccount: Object,
  },
  mounted() {
    if (!this.isMagazine) {
      this.fetchPaymentTypes();
      this.auxValueOld = this.value_old;
      this.auxValueOld = this.value_cash;
    }

    this.setValueDefaultInputs();
    this.hasWarranty = (this.productSelected.warranty === '1')
    this.hasAssembly = (this.productSelected.assembly === '1')

    this.$root.$on('clearFields', () => this.clearImages());
    this.$root.$on('handle-cropped-image', (payload) => this.previewImageOnContent(payload));
    this.$root.$on('is-barcode', (payload) => this.isImageBarcode = payload);
    this.$root.$on('error-form', (payload) => this.addErrorsForm(payload.field, payload.message));
    this.$root.$on('clean-error-form', (payload) => this.cleanErrorsForm(payload.field));
    this.$root.$on('posterShouldCreate', () => this.setValueDefaultInputs());
    this.$root.$on('error-form-clean', (payload) => this.cleanErrorsForm(payload.field));
  },
  watch: {
    hasWarranty(value) {
      this.warranty = value
    },
    hasAssembly(value) {
      this.assembly = value
    },
    base_total_value() {
      this.calculateBaseParcelValue();
    },
    base_parcel_quantity() {
      this.calculateBaseParcelValue();
    },
    productSelected() {
      this.setValueDefaultInputs()
    },
    inputs(value) {
      if (this.isMagazine) {
        this.alterWithDownPayment(!!value);
        this.hasWithoutPaymentInitial = !!value;
      }

      if (this.isPosterLoaded && !this.isMagazine) {
        if (this.inArray('inputs')) {
          this.calculateInputs();
        }
      }
    },
    async template() {
      this.getPresentDataRoles();
      if (this.isPosterLoaded && !this.isMagazine) {
        if (this.inArray('value_plot')) {
          this.calculateValuePlot();
        }
        this.calculateValuePlotInterest();

        if (this.isFastshop) {
          await this.setFastshopMarkup();
        }
      }
    },
    has_interest(hasInterest) {
      this.cleanErrorsForm('has_interest');

      if (this.isMagazine && this.isHybrid && hasInterest) {
        hasInterest = parseFloat(hasInterest.toString().replace(/\./g, '').replace(',', '.'));
        const cetPy = (Math.pow((1 + (hasInterest / 100)), (12 / 360 * 365)) - 1) * 100;
        this.cet = (cetPy / 12).toFixed(2);
        this.cet_py = cetPy.toFixed(2);
      }
    },
    factor(factor) {
      this.rate = {
        financing_ratio_with_down_payment: factor,
        financing_ratio_without_down_payment: factor,
      };
      this.calculateValuePlotByFactor();
      this.calculateValuePlotByFactor2();
      if (!this.isMagazine) {
        this.calculateInputs();
      }
    },
    unitary_value(value) {
      if (value) {
        this.calculateSpareValue();
        this.calculateSpareValueWithQuantityFractional();
      }
    },
    with_down_payment() {
      this.calculateValuePlotByFactor();
      this.calculateValuePlotByFactor2();
      if (!this.isMagazine) {
        this.calculateInputs();
      }
    },
    discount() {
      if (this.isPosterLoaded) {
        this.calculateValueOld();
        this.calculateValueInCashByDiscount();
      }
    },
    exclusive_value_cash() {
      if (this.isPosterLoaded) {
        this.calculateExclusiveValuePlot();
      }
    },
    exclusive_value_cash_2() {
      if (this.isPosterLoaded) {
        this.calculateExclusiveValuePlot2();
      }
    },
    value_cash() {
      if (this.isPosterLoaded) {
        if (this.inArray('discount') && this.inArray('value_old')) {
          this.calculateValueOld();
        }
        if (this.inArray('value_sum') && this.inArray('value_old')) {
          this.calculateValueSum();
        }
        if (this.inArray('value_divided') && this.inArray('value_old')) {
          this.calculateValueDivided();
        }
        if ((this.inArray('parceled') || this.inArray('parceled_inline')) && this.inArray('value_plot')) {
          this.calculateValuePlot();
        }
        if ((this.inArray('parceled') || this.inArray('parceled_inline')) && this.inArray('value_plot_separated')) {
          this.calculateValuePlotSeparated();
        }
        if (this.inArray('parcel_separated_2') && this.inArray('value_plot_separated_2')) {
          this.calculateValuePlotSeparated2();
        }
        if (this.inArray('value_plot_interest')) {
          this.calculateValuePlotInterest();
        }
        if (this.inArray('value_plot_interest_2')) {
          this.calculateValuePlotInterest2();
        }
        this.calculateSpare();
        if (this.inArray('value_bundle')) {
          this.calculateValueBundle();
        }
        //reduced_value
        if (this.inArray('reduced_value') && (this.inArray('spare') || this.inArray('spare_inline'))) {
          this.calculateSpareByReducedValue();
        }
        if (this.inArray('discount') && this.inArray('reduced_value')) {
          this.calculateReducedValue();
        }
        if (this.inArray('discount') && this.inArray('value_in_cash')) {
          this.calculateValueInCashByDiscount();
        }
        if (this.inArray('discount_fastshop') && this.inArray('value_in_cash')) {
          this.calculateDiscountFastshop();
        }
        if (this.inArray('value_sum') && this.inArray('reduced_value')) {
          this.calculateValueSumByReducedValue();
        }
        if (this.inArray('value_divided') && this.inArray('reduced_value')) {
          this.calculateValueDividedByReducedValue();
        }
      }

      this.calculateProportionalValue();
    },
    value_in_cash() {
      if (this.inArray('discount_fastshop') && this.inArray('value_cash')) {
        this.calculateDiscountFastshop();
      }
    },
    value_cash2() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_bundle')) {
          this.calculateValueBundle();
        }

        if (this.inArray('value_plot_interest_2')) {
          this.calculateValuePlotInterest2();
        }
      }
    },
    value_cash3() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_bundle')) {
          this.calculateValueBundle();
        }
      }
    },
    value_bundle() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_old')) {
          this.calculateValueOldByBundle();
        }
        if (this.inArray('reduced_value')) {
          this.calculateReducedValueByBundle();
        }
        if (this.inArray('spare')) {
          this.calculateSpareByBundle();
        }
      }
    },
    discount_bundle() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_old')) {
          this.calculateValueOldByBundle();
        }
        if (this.inArray('reduced_value')) {
          this.calculateReducedValueByBundle();
        }
      }
    },
    value_old() {
      if (this.isPosterLoaded) {
        if (this.inArray('spare') || this.inArray('spare_inline')) {
          this.calculateSpare();
          this.calculateSpareValue();
          this.calculateSpareValueWithQuantityFractional();
        }
        if (this.inArray('spared_percent') || this.inArray('spared_percent_inline')) {
          this.calculateSparedPercentage();
        }
        if (this.inArray('parceled') && this.inArray('value_plot')) {
          this.calculateValuePlot();
        }
        if (this.inArray('value_sum')) {
          this.calculateValueSum();
        }
        if (this.inArray('value_divided')) {
          this.calculateValueDivided();
        }
        if (this.inArray('value_plot_interest')) {
          this.calculateValuePlotInterest();
        }
        if (this.inArray('value_plot_interest_2')) {
          this.calculateValuePlotInterest2();
        }
        if (this.inArray('spare')) {
          this.calculateSpareByBundle();
        }
        if (this.inArray('quantity') && this.inArray('promotional_product_value')) {
          this.calculatePromotionalProductValue();
        }
        if (this.inArray('quantity') && this.inArray('value_old')) {
          this.calculateTotalValue();
        }
        if (this.inArray('quantity_fractional') && this.inArray('promotional_product_value')) {
          this.calculatePromotionalProductValueWithQuantityFractional();
        }
        if (this.inArray('quantity_fractional') && this.inArray('value_old')) {
          this.calculateTotalValueWithQuantityFractional();
        }
      }

      this.calculateProportionalValue();
    },
    reduced_value() {
      if (this.isPosterLoaded) {
        if (this.inArray('spare') || this.inArray('spare_inline')) {
          this.calculateSpareByReducedValue();

          this.calculateSpareValueByReducedValue();
          this.calculateSpareValueByReducedValueWithQuantityFractional();
        }
        if (this.inArray('spared_percent') || this.inArray('spared_percent_inline')) {
          this.calculateSparedPercentageByReducedValue();
        }
        if (this.inArray('parceled') && this.inArray('value_plot')) {
          this.calculateValuePlot();
        }
        if (this.inArray('value_sum')) {
          this.calculateValueSumByReducedValue();
        }
        if (this.inArray('value_divided')) {
          this.calculateValueDividedByReducedValue();
        }
        if (this.inArray('value_plot_interest')) {
          this.calculateValuePlotInterest();
        }
        if (this.inArray('value_plot_interest_2')) {
          this.calculateValuePlotInterest2();
        }
        if (this.inArray('spare')) {
          this.calculateSpareByBundleByReducedValue();
        }
      }
    },
    exclusive_parcel() {
      if (this.isPosterLoaded) {
        if (this.inArray('exclusive_value_plot') && this.inArray('exclusive_value_cash')) {
          this.calculateExclusiveValuePlot();
        }
      }
    },
    exclusive_parcel_2() {
      if (this.isPosterLoaded) {
        if (this.inArray('exclusive_value_plot_2') && this.inArray('exclusive_value_cash_2')) {
          this.calculateExclusiveValuePlot2();
        }
      }
    },
    parcel() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_plot')) {
          this.calculateValuePlot();
        }
        if (this.inArray('value_plot_separated')) {
          this.calculateValuePlotSeparated();
        }
        if (this.inArray('value_remaining') && this.inArray('total_term')) {
          this.calculateValueRemaining();
        }
        if (this.inArray('value_remaining') && this.inArray('total_term_2')) {
          this.calculateValueRemaining2();
        }
      }
    },
    parcel_separated_2() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_plot_separated_2')) {
          this.calculateValuePlotSeparated2();
        }
      }
    },
    parcel_paid() {
      if (this.isPosterLoaded) {
        if (this.inArray('total_term') && this.inArray('value_remaining')) {
          this.calculateValueRemaining();
        }
        if (this.inArray('total_term_2') && this.inArray('value_remaining')) {
          this.calculateValueRemaining2();
        }
      }
    },
    value_plot() {
      if (this.isPosterLoaded) {
        if (this.inArray('total_term')) {
          this.calculateTotalTerm();
        }
        if (this.inArray('total_term_2')) {
          this.calculateTotalTerm2();
        }
        if (this.inArray('total_term') && this.inArray('value_remaining')) {
          this.calculateValueRemaining();
        }
        if (this.inArray('total_term_2') && this.inArray('value_remaining')) {
          this.calculateValueRemaining2();
        }
      }
    },
    total_term() {
      this.cleanErrorsForm('total_term');

      if (this.isPosterLoaded) {
        let hasParceled = (this.inArray('parceled_interest') || this.inArray('parceled_interest_inline'));
        if (hasParceled && this.inArray('value_plot_interest') && !this.showFields) {
          this.calculateTotalTermValuePlotInterest();
        }
      }
    },

    total_term_2() {
      if (this.isPosterLoaded) {
        let hasParceled = (this.inArray('parceled_interest_2'));
        if (hasParceled && this.inArray('value_plot_interest_2') && !this.showFields) {
          this.calculateTotalTermValuePlotInterest2();
        }
      }
    },
    parceled_interest() {
      if (this.isPosterLoaded) {
        if (this.inArray('total_term')) {
          this.calculateTotalTermValuePlotInterest();
        }
        if (this.inArray('total_term_2')) {
          this.calculateTotalTermValuePlotInterest2();
        }
        if (this.inArray('value_plot_interest') && this.inArray('payment_type')) {
          this.calculateValuePlotInterest();
        }
        if (this.inArray('value_plot_interest_2') && this.inArray('payment_type')) {
          this.calculateValuePlotInterest2();
        }
        if (this.subDomain == 'magazineluiza') {
          this.fetchPaymentTypes();
        }
      }
    },

    parceled_interest_2() {
      if (this.isPosterLoaded) {
        if (this.inArray('total_term_2')) {
          this.calculateTotalTermValuePlotInterest2();
        }
        if (this.inArray('value_plot_interest_2') && this.inArray('payment_type')) {
          this.calculateValuePlotInterest2();
        }
        if (this.subDomain === 'magazineluiza') {
          this.fetchPaymentTypes();
        }
      }
    },
    payment_type() {
      this.cleanErrorsForm('payment_type');

      if (this.isPosterLoaded) {
        if (this.inArray('value_plot_interest')) {
          this.calculateValuePlotInterest();
        }
        if (this.inArray('value_plot_interest_2')) {
          this.calculateValuePlotInterest2();
        }
        if (this.inArray('value_plot')) {
          this.calculateValuePlot();
        }
      }
    },

    value_wholeretail() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_wholeretail')) {
          this.calculateWholesaleTotal();
        }
      }
    },

    value_wholesale() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_wholesale')) {
          this.calculateWholesaleTotal();

          this.value_wholesale_card = this.value_wholesale;
        }
      }
    },

    quantity() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_wholesale') || this.inArray('value_wholeretail')) {
          this.calculateWholesaleTotal();
        }
        if (this.inArray('value_old') && this.inArray('promotional_product_value')) {
          this.calculatePromotionalProductValue();
        }
        this.calculateSpareValue();
        if (this.inArray('total_value') && this.inArray('value_old')) {
          this.calculateTotalValue();
        }
      }
    },

    quantity_fractional() {
      if (this.isPosterLoaded) {
        if (this.inArray('value_wholesale') || this.inArray('value_wholeretail')) {
          this.calculateWholesaleTotalWithQuantityFractional();
        }
        if (this.inArray('value_old') && this.inArray('promotional_product_value')) {
          this.calculatePromotionalProductValueWithQuantityFractional();
        }
        this.calculateSpareValueWithQuantityFractional();
        if (this.inArray('total_value') && this.inArray('value_old')) {
          this.calculateTotalValueWithQuantityFractional();
        }
      }
    },
    templateImages(images) {
      if (!!images && images.length > 0) {
        this.$nextTick().then(() => {
          let div = $('[data-toggle="popover"]')
          if (div)
            div.popover();

          this.setRotations();
        });
      }
    },

    proportional_measure() {
      this.calculateProportionalValue();
    },

    proportional_quantity() {
      this.calculateProportionalValue();
    }
  },
  data() {
    return {
      hasWarranty: false,
      hasAssembly: false,
      variablesAux: {
        value_old: 0,
        value_cash: 0,
      },
      datepickerLang: ptBR,
      posterState: this.$store.state.poster,
      productState: this.$store.state.product,
      selectorState: this.$store.state.selector,
      decimal: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
      integer: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
      },
      factorMask: {
        decimal: '.',
        thousands: '',
        precision: 10,
        masked: false,
      },
      rate: {
        financing_ratio_with_down_payment: 1,
        financing_ratio_without_down_payment: 1,
      },
      showFields: (this.$store.state.poster.fields.payment_type != true),
      userPreferences: $.parseJSON($('#user-preferences').val()),
      factor: 0,
      isImageCode: false,
      isImageBarcode: false,
      presentDataRoles: [],
      errors: [],
    };
  },
  computed: {
    percentage_app: {
      get() {
        return this.$store.getters['poster/field']('percentage_app');
      },
      set(value) {
        this.$store.commit('poster/SET_PERCENTAGE_APP', value);
      },
    },
    price_app: {
      get() {
        return this.$store.getters['poster/field']('price_app');
      },
      set(value) {
        this.$store.commit('poster/SET_PRICE_APP', value);
      },
    },
    limit_app: {
      get() {
        return this.$store.getters['poster/field']('limit_app');
      },
      set(value) {
        this.$store.commit('poster/SET_LIMIT_APP', value);
      },
    },
    percentage_card: {
      get() {
        return this.$store.getters['poster/field']('percentage_card');
      },
      set(value) {
        this.$store.commit('poster/SET_PERCENTAGE_CARD', value);
      },
    },
    price_card: {
      get() {
        return this.$store.getters['poster/field']('price_card');
      },
      set(value) {
        this.$store.commit('poster/SET_PRICE_CARD', value);
      },
    },
    limit_card: {
      get() {
        return this.$store.getters['poster/field']('limit_card');
      },
      set(value) {
        this.$store.commit('poster/SET_LIMIT_CARD', value);
      },
    },
    parcel_number_card: {
      get() {
        return this.$store.getters['poster/field']('parcel_number_card');
      },
      set(value) {
        this.$store.commit('poster/SET_PARCEL_NUMBER_CARD', value);
      },
    },
    parcel_price_card: {
      get() {
        return this.$store.getters['poster/field']('parcel_price_card');
      },
      set(value) {
        this.$store.commit('poster/SET_PARCEL_PRICE_CARD', value);
      },
    },
    minimum_app: {
      get() {
        return this.$store.getters['poster/field']('minimum_app');
      },
      set(value) {
        this.$store.commit('poster/SET_MINIMUM_APP', value);
      },
    },
    isMatrix() {
      return !!this.onlineAccount.matrix;
    },
    isFastshop() {
      return this.onlineAccount.integration_type === 'fastshop';
    },
    hasWithoutPaymentInitial: {
      get() {
        return this.$store.getters['poster/field']('has_without_payment_initial');
      },
      set(value) {
        this.$store.commit('poster/SET_HAS_WITHOUT_PAYMENT_INITIAL', value);
      },
    },
    maxPrice() {
      const originPrice = this.valueToDouble(this.productSelected.old_price);
      return (originPrice <= 0) ? originPrice : (originPrice + Math.round(originPrice * 0.2));
    },
    minPrice() {
      const originPrice = this.valueToDouble(this.productSelected.old_price);
      return (originPrice <= 0) ? originPrice : (originPrice - Math.round(originPrice * 0.2));
    },
    unit_proportional: {
      get() {
        return this.productSelected.unit_proportional;
      },
      set(unitProportional) {
        this.$store.commit('poster/SET_UNIT_PROPORTIONAL', unitProportional);
      },
    },
    inputs: {
      get() {
        return this.$store.getters['poster/field']('inputs');
      },
      set(value) {
        this.$store.commit('poster/SET_INPUTS', value);
      },
    },
    insert_custom_qrcode: {
      get() {
        return this.$store.getters['poster/field']('insert_custom_qrcode');
      },
      set(value) {
        this.$store.commit('poster/SET_INSERT_CUSTOM_QR_CODE', value);
      },
    },
    offer_information: {
      get() {
        return this.$store.getters['poster/field']('offer_information');
      },
      set(value) {
        this.$store.commit('poster/SET_OFFER_INFORMATION', value);
      },
    },
    insert_offer_information: {
      get() {
        return this.$store.getters['poster/field']('insert_offer_information');
      },
      set(value) {
        this.$store.commit('poster/SET_INSERT_OFFER_INFORMATION', value);
      },
    },
    insert_qrcode: {
      get() {
        return this.$store.getters['poster/field']('insert_qrcode');
      },
      set(value) {
        this.$store.commit('poster/SET_INSERT_QR_CODE', value);
      },
    },
    insert_value_cash_tag: {
      get() {
        return this.$store.getters['poster/field']('insert_value_cash_tag');
      },
      set(value) {
        this.$store.commit('poster/SET_INSERT_VALUE_CASH_TAG', value);
      },
    },
    insertBarcode: {
      get() {
        return this.$store.getters['poster/field']('insert_barcode');
      },
      set(value) {
        this.$store.commit('poster/SET_INSERT_BAR_CODE', value);
      },
    },
    ibm_code: {
      get() {
        return this.$store.getters['poster/field']('ibm_code');
      },
      set(value) {
        return this.$store.commit('poster/SET_IBM_CODE', value);
      },
    },
    custom_qr_code: {
      get() {
        return this.$store.getters['poster/field']('custom_qr_code');
      },
      set(value) {
        return this.$store.commit('poster/SET_CUSTOM_QR_CODE', value);
      },
    },
    qr_code: {
      get() {
        return this.$store.getters['poster/field']('qr_code');
      },
      set(value) {
        return this.$store.commit('poster/SET_QR_CODE', value);
      },
    },
    bar_code: {
      get() {
        return this.$store.getters['poster/field']('bar_code');
      },
      set(value) {
        return this.$store.commit('poster/SET_BAR_CODE', value);
      },
    },
    showFactorField() {
      return this.isHybrid && !!(this.subDomain == 'magazineluiza');
    },
    showFactorFieldBlackFriday() {
      return !!(this.subDomain == 'magazineluiza');
    },
    isHybrid() {
      return this.selectorState.isHybrid;
    },
    showDate() {
      return this.insertExpirationDates;
    },
    showProductDate() {
      return this.insertProductExpirationDates;
    },
    showProductOlder() {
      return this.insertProductOlder;
    },
    listOfUnits() {
      return this.productState.units;
    },
    listOfProducts() {
      return this.productState.products;
    },
    listOfPaymentTypes() {
      return this.posterState.payment_types;
    },
    listOfProportionalMeasures() {
      return this.posterState.proportional_measures;
    },
    fields() {
      if (this.selectorState.template) {
        return this.selectorState.template.fields.map(function (field) {
          return field.poster_field.field_id;
        });
      }
      return undefined;
    },
    with_down_payment: {
      get() {
        return this.$store.getters['poster/getWithDownPayment'];
      },
      set(withDownPayment) {
        this.$store.commit('poster/SET_WITH_DOWN_PAYMENT', withDownPayment);
      },
    },
    payment_type_id: {
      get() {
        return this.$store.getters['poster/getPaymentTypeId'];
      },
      set(payment_type_id) {
        this.$store.commit('poster/SET_PAYMENT_TYPE_ID', payment_type_id);
      },
    },
    productPromotionalSelected: {
      get() {
        return this.$store.getters['poster/getPromotionalProduct'];
      },
      set(productSelected) {
        this.$store.commit('poster/SET_PROMOTION_PRODUCT', productSelected);
      },
    },
    wholesaleUnitSelected: {
      get() {
        return this.$store.getters['poster/field']('sales_unit_wholesale');
      },
      set(unitSelected) {
        this.$store.commit('poster/SET_SALES_UNIT_WHOLESALE', unitSelected);
      },
    },
    promotionUnitSelected: {
      get() {
        return this.$store.getters['poster/field']('promotion_unit');
      },
      set(unitSelected) {
        this.$store.commit('poster/SET_PROMOTION_UNIT', unitSelected);
      },
    },
    promotionUnit2Selected: {
      get() {
        return this.productPromotionalSelected.unit2;
      },
      set(unitSelected) {
        this.$store.commit('poster/SET_PROMOTION_UNIT2', unitSelected);
      },
    },
    cet_py: {
      set(cet_py) {
        this.$store.commit('poster/SET_CET_PY', cet_py);
      },
      get() {
        return this.$store.getters['poster/field']('cet_py');
      },
    },
    cet: {
      set(cet) {
        this.$store.commit('poster/SET_CET', cet);
      },
      get() {
        return this.$store.getters['poster/field']('cet');
      },
    },
    discount: {
      set(discount) {
        this.$store.commit('poster/SET_DISCOUNT', discount);
      },
      get() {
        return this.$store.getters['poster/field']('discount');
      },
    },
    discount_fastshop: {
      set(discount_fastshop) {
        this.$store.commit('poster/SET_DISCOUNT_FASTSHOP', discount_fastshop);
      },
      get() {
        return this.$store.getters['poster/field']('discount_fastshop');
      },
    },
    discount_bundle: {
      set(discount_bundle) {
        this.$store.commit('poster/SET_DISCOUNT_BUNDLE', discount_bundle);
      },
      get() {
        return this.$store.getters['poster/field']('discount_bundle');
      },
    },
    has_interest: {
      set(has_interest) {
        this.$store.commit('poster/SET_HAS_INTEREST', has_interest);
      },
      get() {
        return this.$store.getters['poster/field']('has_interest');
      },
    },
    legal_informations: {
      set(legal_informations) {
        this.$store.commit('poster/SET_LEGAL_INFORMATIONS', legal_informations);
      },
      get() {
        return this.$store.getters['poster/field']('legal_informations');
      },
    },
    main_description: {
      set(main_description) {
        this.$store.commit('poster/SET_MAIN_DESCRIPTION', main_description);
      },
      get() {
        return this.$store.getters['poster/field']('main_description');
      },
    },
    from_wholesale: {
      set(from_wholesale) {
        this.$store.commit('poster/SET_FROM_WHOLESALE', from_wholesale);
      },
      get() {
        return this.$store.getters['poster/field']('from_wholesale');
      },
    },
    from_large: {
      set(from_large) {
        this.$store.commit('poster/SET_FROM_LARGE', from_large);
      },
      get() {
        return this.$store.getters['poster/field']('from_large');
      },
    },
    proportional_measure: {
      set(proportional_measure) {
        this.$store.commit('poster/SET_PROPORTIONAL_MEASURE', proportional_measure);
      },
      get() {
        return this.$store.getters['poster/field']('proportional_measure');
      },
    },
    proportional_quantity: {
      set(proportional_quantity) {
        this.$store.commit('poster/SET_PROPORTIONAL_QUANTITY', proportional_quantity);
      },
      get() {
        return this.$store.getters['poster/field']('proportional_quantity');
      },
    },
    product_proportional_value: {
      set(product_proportional_value) {
        this.$store.commit('poster/SET_PRODUCT_PROPORTIONAL_VALUE', product_proportional_value);
      },
      get() {
        return this.$store.getters['poster/field']('product_proportional_value');
      }
    },
    minor_description: {
      set(minor_description) {
        this.$store.commit('poster/SET_MINOR_DESCRIPTION', minor_description);
      },
      get() {
        return this.$store.getters['poster/field']('minor_description');
      },
    },
    exclusive_parcel: {
      set(exclusive_parcel) {
        this.$store.commit('poster/SET_EXCLUSIVE_PARCEL', exclusive_parcel);
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_parcel');
      },
    },
    exclusive_parcel_2: {
      set(exclusive_parcel_2) {
        this.$store.commit('poster/SET_EXCLUSIVE_PARCEL_2', exclusive_parcel_2);
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_parcel_2');
      },
    },
    parcel: {
      set(parcel) {
        this.$store.commit('poster/SET_PARCEL', parcel);
      },
      get() {
        return this.$store.getters['poster/field']('parcel');
      },
    },
    parcel_separated_2: {
      set(parcel_separated_2) {
        this.$store.commit('poster/SET_PARCEL_SEPARATED_2', parcel_separated_2);
      },
      get() {
        return this.$store.getters['poster/field']('parcel_separated_2');
      },
    },
    parcel_paid: {
      set(parcel_paid) {
        this.$store.commit('poster/SET_PARCEL_PAID', parcel_paid);
      },
      get() {
        return this.$store.getters['poster/field']('parcel_paid');
      },
    },
    parceled_interest: {
      set(parceled_interest) {
        this.$store.commit('poster/SET_PARCELED_INTEREST', parceled_interest);
      },
      get() {
        return this.$store.getters['poster/field']('parceled_interest');
      },
    },

    parceled_interest_2: {
      set(parceled_interest_2) {
        this.$store.commit('poster/SET_PARCELED_INTEREST_2', parceled_interest_2);
      },
      get() {
        return this.$store.getters['poster/field']('parceled_interest_2');
      },
    },
    parceled: {
      set(parceled) {
        this.$store.commit('poster/SET_PARCELED', parceled);
      },
      get() {
        return this.$store.getters['poster/field']('parceled');
      },
    },
    payment_type: {
      set(payment_type) {
        this.$store.commit('poster/SET_PAYMENT_TYPE', payment_type);
      },
      get() {
        return this.$store.getters['poster/field']('payment_type');
      },
    },
    condition: {
      set(condition) {
        this.$store.commit('poster/SET_CONDITION', condition);
      },
      get() {
        return this.$store.getters['poster/field']('condition');
      },
    },
    selected_type: {
      set(payment_type) {
        this.$store.commit('poster/SET_SELECTED_TYPE', payment_type);
        this.$store.commit('poster/SET_PAYMENT_TYPE', payment_type);
        this.payment_type = payment_type;
      },
      get() {
        return this.posterState.selected_type;
      },
    },
    product_code: {
      set(product_code) {
        this.$store.commit('poster/SET_PRODUCT_CODE', product_code);
      },
      get() {
        return this.$store.getters['poster/field']('product_code');
      },
    },
    promotion_description: {
      set(promotion_description) {
        this.$store.commit('poster/SET_PROMOTION_DESCRIPTION', promotion_description);
      },
      get() {
        return this.$store.getters['poster/field']('promotion_description');
      },
    },
    promotion_main_description: {
      set(promotion_main_description) {
        this.$store.commit('poster/SET_PROMOTION_MAIN_DESCRIPTION', promotion_main_description);
      },
      get() {
        return this.$store.getters['poster/field']('promotion_main_description');
      },
    },
    promotion_minor_description: {
      set(promotion_minor_description) {
        this.$store.commit('poster/SET_PROMOTION_MINOR_DESCRIPTION', promotion_minor_description);
      },
      get() {
        return this.$store.getters['poster/field']('promotion_minor_description');
      },
    },
    promotion_product: {
      set(promotion_product) {
        this.$store.commit('poster/SET_PROMOTION_PRODUCT', promotion_product);
      },
      get() {
        return this.$store.getters['poster/field']('promotion_product');
      },
    },
    promotion_unit: {
      set(promotion_unit) {
        this.$store.commit('poster/SET_PROMOTION_UNIT', promotion_unit);
      },
      get() {
        return this.$store.getters['poster/field']('promotion_unit');
      },
    },
    promotion_unit2: {
      set(promotion_unit2) {
        this.$store.commit('poster/SET_PROMOTION_UNIT2', promotion_unit2);
      },
      get() {
        return this.$store.getters['poster/field']('promotion_unit2');
      },
    },
    promotional_product_value: {
      set(promotional_product_value) {
        this.$store.commit('poster/SET_PROMOTIONAL_PRODUCT_VALUE', promotional_product_value);
      },
      get() {
        return this.$store.getters['poster/field']('promotional_product_value');
      },
    },
    quantity: {
      set(quantity) {
        this.$store.commit('poster/SET_QUANTITY', quantity);
      },
      get() {
        return this.$store.getters['poster/field']('quantity');
      },
    },
    quantity_fractional: {
      set(quantity_fractional) {
        this.$store.commit('poster/SET_QUANTITY_FRACTIONAL', quantity_fractional);
      },
      get() {
        return this.$store.getters['poster/field']('quantity_fractional');
      },
    },
    rates_info: {
      set(rates_info) {
        this.$store.commit('poster/SET_RATES_INFO', rates_info);
      },
      get() {
        return this.$store.getters['poster/field']('rates_info');
      },
    },
    sales_unit_wholesale: {
      set(sales_unit_wholesale) {
        this.$store.commit('poster/SET_SALES_UNIT_WHOLESALE', sales_unit_wholesale);
      },
      get() {
        return this.$store.getters['poster/field']('sales_unit_wholesale');
      },
    },
    sales_unit: {
      set(sales_unit) {
        this.$store.commit('poster/SET_SALES_UNIT', sales_unit);
      },
      get() {
        return this.$store.getters['poster/field']('sales_unit');
      },
    },
    sales_unit2: {
      set(sales_unit2) {
        this.$store.commit('poster/SET_SALES_UNIT2', sales_unit2);
      },
      get() {
        return this.$store.getters['poster/field']('sales_unit2');
      },
    },
    sales_unit3: {
      set(sales_unit3) {
        this.$store.commit('poster/SET_SALES_UNIT3', sales_unit3);
      },
      get() {
        return this.$store.getters['poster/field']('sales_unit3');
      },
    },
    spare: {
      set(spare) {
        this.$store.commit('poster/SET_SPARE', spare);
      },
      get() {
        return this.$store.getters['poster/field']('spare');
      },
    },
    spared_percent: {
      set(spared_percent) {
        this.$store.commit('poster/SET_SPARED_PERCENT', spared_percent);
      },
      get() {
        return this.$store.getters['poster/field']('spared_percent');
      },
    },
    total_term: {
      set(total_term) {
        this.$store.commit('poster/SET_TOTAL_TERM', total_term);
      },
      get() {
        return this.$store.getters['poster/field']('total_term');
      },
    },

    total_term_2: {
      set(total_term_2) {
        this.$store.commit('poster/SET_TOTAL_TERM_2', total_term_2);
      },
      get() {
        return this.$store.getters['poster/field']('total_term_2');
      },
    },
    valid_from: {
      set(valid_from) {
        this.cleanErrorsForm('valid_from');

        if (typeof this.valid_until != 'undefined' && dayjs(valid_from).isAfter(this.valid_until)) {
          this.addErrorsForm('valid_from', '\'Válido até\' deve ser maior que \'Válido de\'!');
          this.$root.throwFlashMessage('warning', 'Verifique os campos incorretos');
        }
        this.$store.commit('poster/SET_VALID_FROM', valid_from);
      },
      get() {
        return this.$store.getters['poster/field']('valid_from');
      },
    },
    valid_until: {
      set(valid_until) {
        this.cleanErrorsForm('valid_until');

        if (typeof this.valid_from != 'undefined' && dayjs(valid_until).isBefore(this.valid_from)) {
          this.addErrorsForm('valid_until', '\'Válido até\' deve ser maior que \'Válido de\'!');
          this.$root.throwFlashMessage('warning', 'Verifique os campos incorretos');
        }
        if (dayjs(valid_until).isBefore(dayjs().subtract(1, 'days'))) {
          this.addErrorsForm('valid_until', '\'Válido até\' deve ser maior que hoje!');
          this.$root.throwFlashMessage('warning', 'Verifique os campos incorretos');
        }

        this.$store.commit('poster/SET_VALID_UNTIL', valid_until);
      },
      get() {
        return this.$store.getters['poster/field']('valid_until');
      },
    },
    validate: {
      set(validate) {
        this.$store.commit('poster/SET_VALIDATE', validate);
      },
      get() {
        return this.$store.getters['poster/field']('validate');
      },
    },
    product_older: {
      set(product_older) {
        this.$store.commit('poster/SET_PRODUCT_OLDER', product_older);
      },
      get() {
        return this.$store.getters['poster/field']('product_older');
      },
    },
    free_value: {
      set(free_value) {
        this.$store.commit('poster/SET_FREE_VALUE', free_value);
      },
      get() {
        return this.$store.getters['poster/field']('free_value');
      },
    },
    base_value: {
      set(base_value) {
        this.$store.commit('poster/SET_BASE_VALUE', base_value);
      },
      get() {
        return this.$store.getters['poster/field']('base_value');
      },
    },
    base_total_value: {
      set(base_total_value) {
        this.$store.commit('poster/SET_BASE_TOTAL_VALUE', base_total_value);
      },
      get() {
        return this.$store.getters['poster/field']('base_total_value');
      },
    },
    base_parcel_quantity: {
      set(base_parcel_quantity) {
        this.$store.commit('poster/SET_BASE_PARCEL_QUANTITY', base_parcel_quantity);
      },
      get() {
        return this.$store.getters['poster/field']('base_parcel_quantity');
      },
    },
    base_parcel_value: {
      set(base_parcel_value) {
        this.$store.commit('poster/SET_BASE_PARCEL_VALUE', base_parcel_value);
      },
      get() {
        return this.$store.getters['poster/field']('base_parcel_value');
      },
    },
    derived_code: {
      set(derived_code) {
        this.$store.commit('poster/SET_DERIVED_CODE', derived_code);
      },
      get() {
        return this.$store.getters['poster/field']('derived_code');
      },
    },
    warranty: {
      set(warranty) {
        this.$store.commit('poster/SET_WARRANTY', warranty);
      },
      get() {
        return this.$store.getters['poster/field']('warranty');
      },
    },
    assembly: {
      set(assembly) {
        this.$store.commit('poster/SET_ASSEMBLY', assembly);
      },
      get() {
        return this.$store.getters['poster/field']('assembly');
      },
    },
    about_product: {
      set(about_product) {
        this.$store.commit('poster/SET_ABOUT_PRODUCT', about_product);
      },
      get() {
        return this.$store.getters['poster/field']('about_product');
      },
    },
    supported_weight: {
      set(supported_weight) {
        this.$store.commit('poster/SET_SUPPORTED_WEIGHT', supported_weight);
      },
      get() {
        return this.$store.getters['poster/field']('supported_weight');
      },
    },
    value_cash: {
      set(value_cash) {
        this.$store.commit('poster/SET_VALUE_CASH', value_cash);
      },
      get() {
        return this.$store.getters['poster/field']('value_cash');
      },
    },
    value_cash2: {
      set(value_cash2) {
        this.$store.commit('poster/SET_VALUE_CASH2', value_cash2);
      },
      get() {
        return this.$store.getters['poster/field']('value_cash2');
      },
    },
    value_cash3: {
      set(value_cash3) {
        this.$store.commit('poster/SET_VALUE_CASH3', value_cash3);
      },
      get() {
        return this.$store.getters['poster/field']('value_cash3');
      },
    },
    simple_description: {
      get() {
        return this.productSelected.simple_description;
      },
      set(simpleDescription) {
        this.$store.commit('poster/SET_SIMPLE_DESCRIPTION', simpleDescription);
      },
    },
    simple_description2: {
      get() {
        return this.productSelected.simple_description2;
      },
      set(simpleDescription2) {
        this.$store.commit('poster/SET_SIMPLE_DESCRIPTION2', simpleDescription2);
      },
    },
    simple_description3: {
      get() {
        return this.productSelected.simple_description3;
      },
      set(simpleDescription3) {
        this.$store.commit('poster/SET_SIMPLE_DESCRIPTION3', simpleDescription3);
      },
    },
    simple_description4: {
      get() {
        return this.productSelected.simple_description4;
      },
      set(simpleDescription4) {
        this.$store.commit('poster/SET_SIMPLE_DESCRIPTION4', simpleDescription4);
      },
    },
    simple_description5: {
      get() {
        return this.productSelected.simple_description5;
      },
      set(simpleDescription5) {
        this.$store.commit('poster/SET_SIMPLE_DESCRIPTION5', simpleDescription5);
      },
    },
    reoperated_product: {
      get() {
        return this.productSelected.reoperated_product;
      },
      set(reoperated_product) {
        this.$store.commit('poster/SET_REOPERATED_PRODUCT', reoperated_product);
      },
    },
    product_other_colors: {
      get() {
        return this.productSelected.product_other_colors;
      },
      set(product_other_colors) {
        this.$store.commit('poster/SET_PRODUCT_OTHER_COLORS', product_other_colors);
      },
    },
    product_other_sizes: {
      get() {
        return this.productSelected.product_other_sizes;
      },
      set(product_other_sizes) {
        this.$store.commit('poster/SET_PRODUCT_OTHER_SIZES', product_other_sizes);
      },
    },
    product_comments: {
      get() {
        return this.productSelected.product_comments;
      },
      set(product_comments) {
        this.$store.commit('poster/SET_PRODUCT_COMMENTS', product_comments);
      },
    },
    product_evaluation: {
      get() {
        return this.productSelected.product_evaluation;
      },
      set(product_evaluation) {
        this.$store.commit('poster/SET_PRODUCT_EVALUATION', product_evaluation);
      },
    },
    product_material: {
      get() {
        return this.productSelected.product_material;
      },
      set(product_material) {
        this.$store.commit('poster/SET_PRODUCT_MATERIAL', product_material);
      },
    },
    product_depth: {
      get() {
        return this.productSelected.product_depth;
      },
      set(product_depth) {
        this.$store.commit('poster/SET_PRODUCT_DEPTH', product_depth);
      },
    },
    product_height: {
      get() {
        return this.productSelected.product_height;
      },
      set(product_height) {
        this.$store.commit('poster/SET_PRODUCT_HEIGHT', product_height);
      },
    },
    product_width: {
      get() {
        return this.productSelected.product_width;
      },
      set(product_width) {
        this.$store.commit('poster/SET_PRODUCT_WIDTH', product_width);
      },
    },
    retail_packaging: {
      get() {
        return this.$store.getters['poster/field']('retail_packaging');
      },
      set(retail_packaging) {
        this.$store.commit('poster/SET_RETAIL_PACKAGING', retail_packaging);
      },
    },
    wholesale_packing: {
      get() {
        return this.$store.getters['poster/field']('wholesale_packing');
      },
      set(wholesale_packing) {
        this.$store.commit('poster/SET_WHOLESALE_PACKING', wholesale_packing);
      },
    },
    big_packing: {
      get() {
        return this.$store.getters['poster/field']('big_packing');
      },
      set(big_packing) {
        this.$store.commit('poster/SET_BIG_PACKING', big_packing);
      },
    },
    validation: {
      get() {
        return this.$store.getters['poster/field']('validation');
      },
      set(big_packing) {
        this.$store.commit('poster/SET_VALIDATION', big_packing);
      },
    },
    retail_taxation: {
      get() {
        return this.$store.getters['poster/field']('retail_taxation');
      },
      set(retail_taxation) {
        this.$store.commit('poster/SET_RETAIL_TAXATION', retail_taxation);
      },
    },
    wholesale_taxation: {
      get() {
        return this.$store.getters['poster/field']('wholesale_taxation');
      },
      set(wholesale_taxation) {
        this.$store.commit('poster/SET_WHOLESALE_TAXATION', wholesale_taxation);
      },
    },
    big_taxation: {
      get() {
        return this.$store.getters['poster/field']('big_taxation');
      },
      set(big_taxation) {
        this.$store.commit('poster/SET_BIG_TAXATION', big_taxation);
      },
    },
    light_taxation: {
      get() {
        return this.$store.getters['poster/field']('light_taxation');
      },
      set(light_taxation) {
        this.$store.commit('poster/SET_LIGHT_TAXATION', light_taxation);
      },
    },
    retail_media: {
      get() {
        return this.$store.getters['poster/field']('retail_media');
      },
      set(retail_media) {
        this.$store.commit('poster/SET_RETAIL_MEDIA', retail_media);
      },
    },
    wholesale_media: {
      get() {
        return this.$store.getters['poster/field']('wholesale_media');
      },
      set(wholesale_media) {
        this.$store.commit('poster/SET_WHOLESALE_MEDIA', wholesale_media);
      },
    },
    big_media: {
      get() {
        return this.$store.getters['poster/field']('big_media');
      },
      set(big_media) {
        this.$store.commit('poster/SET_BIG_MEDIA', big_media);
      },
    },
    light_media: {
      get() {
        return this.$store.getters['poster/field']('light_media');
      },
      set(light_media) {
        this.$store.commit('poster/SET_LIGHT_MEDIA', light_media);
      },
    },
    big_price: {
      get() {
        return this.$store.getters['poster/field']('big_price');
      },
      set(big_price) {
        this.$store.commit('poster/SET_BIG_PRICE', big_price);
      },
    },
    light_price: {
      get() {
        return this.$store.getters['poster/field']('light_price');
      },
      set(light_price) {
        this.$store.commit('poster/SET_LIGHT_PRICE', light_price);
      },
    },
    light_quantity: {
      get() {
        return this.$store.getters['poster/field']('light_quantity');
      },
      set(light_quantity) {
        this.$store.commit('poster/SET_LIGHT_QUANTITY', light_quantity);
      },
    },
    free_text: {
      get() {
        return this.productSelected.free_text;
      },
      set(free_text) {
        this.$store.commit('poster/SET_FREE_TEXT', free_text);
      },
    },
    free_text2: {
      get() {
        return this.productSelected.free_text2;
      },
      set(free_text2) {
        this.$store.commit('poster/SET_FREE_TEXT2', free_text2);
      },
    },
    free_text3: {
      get() {
        return this.productSelected.free_text3;
      },
      set(free_text3) {
        this.$store.commit('poster/SET_FREE_TEXT3', free_text3);
      },
    },
    value_bundle: {
      set(value_bundle) {
        this.$store.commit('poster/SET_VALUE_BUNDLE', value_bundle);
      },
      get() {
        return this.$store.getters['poster/field']('value_bundle');
      },
    },
    value_divided: {
      set(value_divided) {
        this.$store.commit('poster/SET_VALUE_DIVIDED', value_divided);
      },
      get() {
        return this.$store.getters['poster/field']('value_divided');
      },
    },
    reduced_value: {
      set(reduced_value) {
        this.$store.commit('poster/SET_REDUCED_VALUE', reduced_value);
      },
      get() {
        return this.$store.getters['poster/field']('reduced_value');
      },
    },
    value_old: {
      set(value_old) {
        this.$store.commit('poster/SET_VALUE_OLD', value_old);
      },
      get() {
        return this.$store.getters['poster/field']('value_old');
      },
    },
    unitary_value: {
      set(unitary_value) {
        this.$store.commit('poster/SET_UNITARY_VALUE', unitary_value);
      },
      get() {
        return this.$store.getters['poster/field']('unitary_value');
      },
    },
    value_in_cash: {
      set(value_in_cash) {
        this.$store.commit('poster/SET_VALUE_IN_CASH', value_in_cash);
      },
      get() {
        return this.$store.getters['poster/field']('value_in_cash');
      },
    },
    exclusive_value_cash: {
      set(exclusive_value_cash) {
        this.$store.commit('poster/SET_EXCLUSIVE_VALUE_CASH', exclusive_value_cash);
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_value_cash');
      },
    },
    exclusive_value_cash_2: {
      set(exclusive_value_cash_2) {
        this.$store.commit('poster/SET_EXCLUSIVE_VALUE_CASH_2', exclusive_value_cash_2);
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_value_cash_2');
      },
    },
    exclusive_value_in_cash: {
      set(exclusive_value_in_cash) {
        this.$store.commit('poster/SET_EXCLUSIVE_VALUE_IN_CASH', exclusive_value_in_cash);
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_value_in_cash');
      },
    },
    exclusive_value_in_cash_2: {
      set(exclusive_value_in_cash_2) {
        this.$store.commit('poster/SET_EXCLUSIVE_VALUE_IN_CASH_2', exclusive_value_in_cash_2);
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_value_in_cash_2');
      },
    },
    cashback_value: {
      set(cashback_value) {
        this.$store.commit('poster/SET_CASHBACK_VALUE', cashback_value);
      },
      get() {
        return this.$store.getters['poster/field']('cashback_value');
      },
    },
    cashback_value_2: {
      set(cashback_value_2) {
        this.$store.commit('poster/SET_CASHBACK_VALUE_2', cashback_value_2);
      },
      get() {
        return this.$store.getters['poster/field']('cashback_value_2');
      },
    },
    total_value: {
      set(total_value) {
        this.$store.commit('poster/SET_TOTAL_VALUE', total_value);
      },
      get() {
        return this.$store.getters['poster/field']('total_value');
      },
    },
    value_plot_interest: {
      set(value_plot_interest) {
        this.$store.commit('poster/SET_VALUE_PLOT_INTEREST', value_plot_interest);
      },
      get() {
        return this.$store.getters['poster/field']('value_plot_interest');
      },
    },

    value_plot_interest_2: {
      set(value_plot_interest_2) {
        this.$store.commit('poster/SET_VALUE_PLOT_INTEREST_2', value_plot_interest_2);
      },
      get() {
        return this.$store.getters['poster/field']('value_plot_interest_2');
      },
    },
    value_plot: {
      set(value_plot) {
        if (this.isPosterLoaded) {
          this.$store.commit('poster/SET_VALUE_PLOT', value_plot);
        }
      },
      get() {
        return this.$store.getters['poster/field']('value_plot');
      },
    },
    value_plot_separated: {
      set(value_plot_separated) {
        if (this.isPosterLoaded) {
          this.$store.commit('poster/SET_VALUE_PLOT_SEPARATED', value_plot_separated);
        }
      },
      get() {
        return this.$store.getters['poster/field']('value_plot_separated');
      },
    },
    value_plot_separated_2: {
      set(value_plot_separated_2) {
        if (this.isPosterLoaded) {
          this.$store.commit('poster/SET_VALUE_PLOT_SEPARATED_2', value_plot_separated_2);
        }
      },
      get() {
        return this.$store.getters['poster/field']('value_plot_separated_2');
      },
    },
    exclusive_value_plot: {
      set(exclusive_value_plot) {
        if (this.isPosterLoaded) {
          this.$store.commit('poster/SET_EXCLUSIVE_VALUE_PLOT', exclusive_value_plot);
        }
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_value_plot');
      },
    },
    exclusive_value_plot_2: {
      set(exclusive_value_plot_2) {
        if (this.isPosterLoaded) {
          this.$store.commit('poster/SET_EXCLUSIVE_VALUE_PLOT_2', exclusive_value_plot_2);
        }
      },
      get() {
        return this.$store.getters['poster/field']('exclusive_value_plot_2');
      },
    },
    value_remaining: {
      set(value_remaining) {
        this.$store.commit('poster/SET_VALUE_REMAINING', value_remaining);
      },
      get() {
        return this.$store.getters['poster/field']('value_remaining');
      },
    },
    value_retail: {
      set(value_retail) {
        this.$store.commit('poster/SET_VALUE_RETAIL', value_retail);
      },
      get() {
        return this.$store.getters['poster/field']('value_retail');
      },
    },
    value_wholeretail: {
      get() {
        return this.$store.getters['poster/field']('value_wholeretail');
      },
      set(value) {
        this.$store.commit('poster/SET_VALUE_WHOLERETAIL', value);
      },
    },
    value_wholeretail_2: {
      get() {
        return this.$store.getters['poster/field']('value_wholeretail_2');
      },
      set(value) {
        this.$store.commit('poster/SET_VALUE_WHOLERETAIL_2', value);
      },
    },
    value_wholeretail_3: {
      get() {
        return this.$store.getters['poster/field']('value_wholeretail_3');
      },
      set(value) {
        this.$store.commit('poster/SET_VALUE_WHOLERETAIL_3', value);
      },
    },
    value_wholeretail_4: {
      get() {
        return this.$store.getters['poster/field']('value_wholeretail_4');
      },
      set(value) {
        this.$store.commit('poster/SET_VALUE_WHOLERETAIL_4', value);
      },
    },
    value_wholeretail_5: {
      get() {
        return this.$store.getters['poster/field']('value_wholeretail_5');
      },
      set(value) {
        this.$store.commit('poster/SET_VALUE_WHOLERETAIL_5', value);
      },
    },
    proportional_value: {
      get() {
        return this.$store.getters['poster/field']('proportional_value');
      },
      set(value) {
        this.$store.commit('poster/SET_PROPORTIONAL_VALUE', value);
      },
    },
    value_sum: {
      set(value_sum) {
        this.$store.commit('poster/SET_VALUE_SUM', value_sum);
      },
      get() {
        return this.$store.getters['poster/field']('value_sum');
      },
    },
    value_total_wholesale: {
      set(value_total_wholesale) {
        this.$store.commit('poster/SET_VALUE_TOTAL_WHOLESALE', value_total_wholesale);
      },
      get() {
        return this.$store.getters['poster/field']('value_total_wholesale');
      },
    },
    value_wholesale: {
      set(value_wholesale) {
        this.$store.commit('poster/SET_VALUE_WHOLESALE', value_wholesale);
      },
      get() {
        return this.$store.getters['poster/field']('value_wholesale');
      },
    },
    value_cash_tag: {
      set(value_cash_tag) {
        this.$store.commit('poster/SET_VALUE_CASH_TAG', value_cash_tag);
      },
      get() {
        return this.$store.getters['poster/field']('value_cash_tag');
      },
    },
    value_wholesale_card: {
      set(value_wholesale_card) {
        this.$store.commit('poster/SET_VALUE_WHOLESALE_CARD', value_wholesale_card);
      },
      get() {
        return this.$store.getters['poster/field']('value_wholesale_card');
      },
    },
    payment_types: {
      set(payment_types) {
        this.$store.commit('poster/SET_PAYMENT_TYPES', payment_types);
      },
      get() {
        return this.$store.getters['poster/getPaymentTypes'];
      },
    },
    quantity2: {
      set(quantity2) {
        this.$store.commit('poster/SET_QUANTITY2', quantity2);
      },
      get() {
        return this.$store.getters['poster/field']('quantity2');
      },
    },
    quantity3: {
      set(quantity3) {
        this.$store.commit('poster/SET_QUANTITY3', quantity3);
      },
      get() {
        return this.$store.getters['poster/field']('quantity3');
      },
    },
    quantity4: {
      set(quantity4) {
        this.$store.commit('poster/SET_QUANTITY4', quantity4);
      },
      get() {
        return this.$store.getters['poster/field']('quantity4');
      },
    },
    quantity5: {
      set(quantity5) {
        this.$store.commit('poster/SET_QUANTITY5', quantity5);
      },
      get() {
        return this.$store.getters['poster/field']('quantity5');
      },
    },
    value_old2: {
      set(value_old2) {
        this.$store.commit('poster/SET_VALUE_OLD2', value_old2);
      },
      get() {
        return this.$store.getters['poster/field']('value_old2');
      },
    },
    value_old3: {
      set(value_old3) {
        this.$store.commit('poster/SET_VALUE_OLD3', value_old3);
      },
      get() {
        return this.$store.getters['poster/field']('value_old3');
      },
    },
    template() {
      return this.$store.getters['selector/getTemplate'];
    },
    productSelected() {
      return this.$store.getters['poster/getSelectedProduct'];
    },
    insertExpirationDates: {
      set(value) {
        this.$store.commit('poster/SET_INSERT_EXPIRATION_DATES', value);
      },
      get() {
        return this.$store.getters['poster/getInsertExpirationDates'];
      },
    },
    insertProductExpirationDates: {
      set(value) {
        if (!value) {
          this.validate = undefined;
        } else {
          if (!this.validate)
            this.validate = new Date();
        }
        this.$store.commit('poster/SET_INSERT_PRODUCT_EXPIRATION_DATES', value);
      },
      get() {
        return this.$store.getters['poster/getInsertProductExpirationDates'];
      },
    },
    insertProductOlder: {
      set(value) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_OLDER', value);
      },
      get() {
        return this.$store.getters['poster/getInsertProductOlder'];
      },
    },
    templateImages() {
      return this.$store.getters['selector/getTemplateImages'];
    },
    posterContent: {
      get() {
        if (typeof this.template != 'undefined') {
          return this.template.content;
        }
        if (typeof this.posterState != 'undefined') {
          return this.$store.getters['poster/field']('content');
        }
      },
      set(content) {
        if (content) {
          this.$store.commit('poster/SET_CONTENT', content);
        }
      },
    },

    verifiedPrice() {
      if (this.isNotUndefinedOrEmpty(this.reduced_value) && this.inArray('reduced_value')) {
        return this.parseToFloat(this.reduced_value || 0)
      }

      if (this.isNotUndefinedOrEmpty(this.value_old) && this.inArray('value_old')) {
        return this.parseToFloat(this.value_old || 0)
      }

      return this.parseToFloat(this.value_cash || 0)
    }
  },

  methods: {
    calculateBaseParcelValue() {
      let baseTotalValue = this.parseToFloat(this.base_total_value || 0);
      let baseParcelQuantity = this.parseToFloat(this.base_parcel_quantity || 0);

      let baseParcelValue = baseTotalValue / baseParcelQuantity;
      this.base_parcel_value = baseParcelValue.toFixed(2);
    },

    async setFastshopMarkup() {
      const isMatrixClass = this.isMatrix
          ? 'fastshop-square'
          : 'fastshop-circle';

      const span = await document.createElement('span');
      await span.setAttribute('class', isMatrixClass);
      const poster = await document.getElementById('preview');

      if (poster) {
        poster.appendChild(span);
      }
    },

    calculateProportionalValue() {
      let hasFields =
          (this.isNotUndefinedOrEmpty(this.proportional_measure) && this.isNotUndefinedOrEmpty(this.proportional_quantity) && this.proportional_quantity > 0)
          && (this.isNotUndefinedOrEmpty(this.value_old) || this.isNotUndefinedOrEmpty(this.value_cash));

      if (hasFields) {
        let proportionalMeasureValue = this.$store.getters['poster/getProportionalMeasureValue'];

        let hasPromotionalPrice = (this.inArray('value_old') || this.inTemplate('VAL_PROM'));

        let price = hasPromotionalPrice
            ? this.parseToFloat(this.value_old || 0)
            : this.parseToFloat(this.value_cash || 0);

        let value = (price * proportionalMeasureValue) / this.proportional_quantity;
        value = value.toFixed(2);
        this.product_proportional_value = this.cleanValue(value);
      }
    },

    setValueDefaultInputs() {
      this.inputs = (this.isMagazine) ? '' : '0';
    },
    valueToDouble(value) {
      return (value) ? +value.replace('.', '').replace(',', '.') : value;
    },
    isValidPriceMargin(value) {
      return true;
      let price = this.valueToDouble(value);
      const originPrice = this.valueToDouble(this.productSelected.old_price);
      if (!originPrice || originPrice <= 0 || !this.isMagazine) {
        return true;
      }
      return price >= this.minPrice && price <= this.maxPrice;
    },
    calculateInputs() {
      let inputs = parseInt(this.inputs || 0);
      if (inputs > 0) {
        this.value_plot_interest = this.calculateValuePlotInterestByInputs(this.verifiedPrice, this.parceled_interest);
        this.total_term = this.calculateTotalTermByInputs(this.parceled_interest, this.value_plot_interest);

        let valueCash2 = this.parseToFloat(this.value_cash2 || 0);
        this.value_plot_interest_2 = this.calculateValuePlotInterestByInputs(valueCash2, this.parceled_interest_2);
        this.total_term_2 = this.calculateTotalTermByInputs(this.parceled_interest_2, this.value_plot_interest_2);
      } else {
        this.calculateValuePlotByFactor()
        this.calculateValuePlotByFactor2()
      }
    },
    calculateValuePlotInterestByInputs(price, parcels) {
      let inputs = parseInt(this.inputs || 0);
      let factor = parseFloat(this.rate.interest || 0);
      let valuePlotInterest = this.calculatePMT(factor, parcels, price, 0, inputs);

      if (this.userPreferences.indexOf('roundToUp') !== -1) {
        valuePlotInterest = Math.ceil(valuePlotInterest * 100) / 100;
      }
      return this.cleanValue(valuePlotInterest);
    },
    calculateTotalTermByInputs(parceledInterest, valuePlotInterest) {
      let parcel = parseInt(parceledInterest || 0);
      let valuePlot = this.parseToFloat(valuePlotInterest || 0);
      let totalTerm = (parcel * valuePlot);
      return this.cleanValue(totalTerm);
    },

    calculatePMT(rate, numParcels, totalValue, futureValue = 0, input = 0) {
      if (rate === 0) {
        return -(totalValue + futureValue) / numParcels;
      }

      let denominator = (1 + rate * input) * ((Math.pow(1 + rate, numParcels) - 1) / rate);
      let payment = (-totalValue * Math.pow(1 + rate, numParcels) - futureValue) / denominator;

      // Tomar o valor absoluto e arredondar para duas casas decimais
      payment = Math.abs(payment);
      payment = payment.toFixed(2);

      return parseFloat(payment); // Retorna o pagamento como um número formatado
    },
    checkIsInPoster(field) {
      return this.presentDataRoles && this.presentDataRoles.includes(field);
    },
    getPresentDataRoles: _.debounce(function () {
      this.presentDataRoles = $.map($('[data-role]'), (element) => $(element).attr('data-role'));
    }, 100),
    showCropImageModal(index) {
      const imageBox = $(`[data-role^="${index}"]`);
      const imageWidth = imageBox.width();
      const imageHeight = imageBox.height();
      this.$root.$emit('show-crop-modal', {
        index: index,
        width: imageWidth,
        height: imageHeight,
      });
    },
    getIndice(installments, interestRate) {
      let interestRateDecimal = interestRate / 100;
      return (interestRateDecimal / (1 - (1 / Math.pow((1 + interestRateDecimal), installments)))).toFixed(4);
    },
    clearField(field) {
      if (!this.$store.getters['poster/field'](field)) {
        this.$store.commit('poster/SET_FIELD_COMPOUND',
            {
              field: field,
              value: ' ',
            });
        setTimeout(() => {
          this.$store.commit('poster/SET_FIELD_COMPOUND',
              {
                field: field,
                value: '',
              });
        }, 100);
      }
    },
    throwPopUp: function (message, delay = 50) {
      this.$root.$emit('show-vueup', {
        color: 'white',
        delay: delay,
        message: message,
        backgroundColor: 'rgba(30, 30, 30, 0.5)',
      });
    },
    alterWithDownPayment(withDownPayment) {
      this.with_down_payment = withDownPayment;
    },
    fetchPaymentTypes() {
      if (this.subDomain == 'magazineluiza') {
        const parceledInterest = this.parceled_interest;
        let campaignId = this.$store.getters['selector/getCampaignId'];
        RateService.fetchPaymentTypes(parceledInterest, campaignId).then((types) => {
          this.payment_types = types;
          this.posterState.payment_types = types;
          if (this.payment_type && !this.payment_types.find((paymentType) => paymentType.sheet_name === this.payment_type)) {
            this.payment_type = undefined;
            this.payment_type_id = undefined;
            this.condition = undefined;
          }
          this.calculateValuePlotInterest();
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', error.message);
        });
      } else {
        RateService.fetchPaymentTypes().then((types) => {
          this.payment_types = _.values(types);
          this.posterState.payment_types = _.values(types);
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', error.message);
        });
      }
    },
    inArray(data_role) {
      return (typeof this.fields != 'undefined' && this.fields.indexOf(data_role) > -1);
    },
    inTemplate(dataRole) {
      return (this.posterContent && _.includes(this.posterContent, dataRole));
    },
    notInArray: function (data_role) {
      return (typeof this.fields == 'undefined' || this.fields.indexOf(data_role) == -1);
    },
    cleanValue: function (value) {
      if (value) {
        value = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        value = (/\.[0-9]{1}$/g.test(value)) ? value + '0' : value;
        value = (/^\d+$/.test(value)) ? value + '.00' : value;
        value = value.toString().replace('.', ',');
      }
      return value;
    },
    parseToFloat(value) {
      if (value) {
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
      }
    },
    isNotUndefinedOrEmpty(value) {
      return (typeof value != 'undefined' && value != '' && value != '0,00');
    },
    calculateValueBundle() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.value_cash2)) {
        let valueCash = this.parseToFloat(this.value_cash);
        let valueCash2 = this.parseToFloat(this.value_cash2);
        let valueCash3 = (this.isNotUndefinedOrEmpty(this.value_cash3)) ? this.parseToFloat(this.value_cash3) : 0;
        this.value_bundle = this.cleanValue(valueCash + valueCash2 + valueCash3);
      }
    },
    calculateValueOldByBundle() {
      if (this.isNotUndefinedOrEmpty(this.value_bundle) && this.isNotUndefinedOrEmpty(this.discount_bundle)) {
        let valueBundle = this.parseToFloat(this.value_bundle);
        let discountBundle = this.parseToFloat(this.discount_bundle);
        let discount = valueBundle * (discountBundle / 100);
        this.value_old = this.cleanValue(valueBundle - discount);
      }
    },
    calculateDiscountFastshop() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.value_in_cash)) {
        let valueCash = this.parseToFloat(this.value_cash) * 100;
        let valueInCash = this.parseToFloat(this.value_in_cash) * 100;
        let spare = (valueCash - valueInCash);
        const percentual = (spare / valueCash) * 100;
        this.discount_fastshop = (isNaN(percentual) || percentual <= 0) ? this.cleanValue(0) : this.cleanValue(percentual);
      }
    },
    calculateReducedValueByBundle() {
      if (this.isNotUndefinedOrEmpty(this.value_bundle) && this.isNotUndefinedOrEmpty(this.discount_bundle)) {
        let valueBundle = this.parseToFloat(this.value_bundle);
        let discountBundle = this.parseToFloat(this.discount_bundle);
        let discount = valueBundle * (discountBundle / 100);
        this.reduced_value = this.cleanValue(valueBundle - discount);
      }
    },
    calculateSpareByBundle() {
      if (this.isNotUndefinedOrEmpty(this.value_bundle) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let valueBundle = this.parseToFloat(this.value_bundle);
        let valueOld = this.parseToFloat(this.value_old);
        this.spare = this.cleanValue(valueBundle - valueOld);
      }
    },
    calculateSpareByBundleByReducedValue() {
      if (this.isNotUndefinedOrEmpty(this.value_bundle) && this.isNotUndefinedOrEmpty(this.reduced_value)) {
        let valueBundle = this.parseToFloat(this.value_bundle);
        let reducedValue = this.parseToFloat(this.reduced_value);
        this.spare = this.cleanValue(valueBundle - reducedValue);
      }
    },
    calculateValueOld: function () {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.discount)) {
        let value = this.parseToFloat(this.value_cash);
        let discount = this.parseToFloat(this.discount);
        let valueOld = value * (1 - (discount / 100));
        this.value_old = (valueOld > 0) ? valueOld : 0;
        this.value_old = this.cleanValue(this.value_old);
      }
    },
    calculateTotalValue() {
      if (this.isNotUndefinedOrEmpty(this.quantity) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let quantity = this.parseToFloat(this.quantity);
        let valueOld = this.parseToFloat(this.value_old);
        quantity = (quantity <= 0) ? 1 : quantity;
        this.total_value = this.cleanValue(quantity * valueOld);
      }
    },
    calculateTotalValueWithQuantityFractional() {
      if (this.isNotUndefinedOrEmpty(this.quantity_fractional) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let quantity = this.quantity_fractional;
        let valueOld = this.parseToFloat(this.value_old);
        quantity = (quantity <= 0) ? 1 : quantity;
        this.total_value = this.cleanValue(quantity * valueOld);
      }
    },
    calculateReducedValue() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.discount)) {
        let value = this.parseToFloat(this.value_cash);
        let discount = this.parseToFloat(this.discount);
        this.reduced_value = this.cleanValue(value * (1 - (discount / 100)));
      }
    },
    calculateValueInCashByDiscount() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.discount)) {
        let value = this.parseToFloat(this.value_cash);
        let discount = this.parseToFloat(this.discount);
        this.value_in_cash = this.cleanValue(value * (1 - (discount / 100)));
      }
    },
    calculateSpare() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let old = this.parseToFloat(this.value_old);
        let cash = this.parseToFloat(this.value_cash);
        let spare = (cash - old);
        spare = (spare > 0) ? spare : 0;
        this.spare = this.cleanValue(spare.toFixed(2));
      }
    },
    calculateSpareByReducedValue() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.reduced_value)) {
        let old = this.parseToFloat(this.reduced_value) * 1000;
        let cash = this.parseToFloat(this.value_cash) * 1000;
        let spare = (cash - old) / 1000;
        spare = (spare > 0) ? spare : 0;
        this.spare = this.cleanValue(spare);
      }
    },
    calculateSparedPercentage() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let old = this.parseToFloat(this.value_old) * 100;
        let cash = this.parseToFloat(this.value_cash) * 100;
        let spare = (cash - old);
        let percentual = (spare / cash) * 100;
        this.spared_percent = (isNaN(percentual)) ? this.cleanValue(0) : this.cleanValue(percentual);
        this.spare_inline = this.spared_percent;
      }
    },
    calculateSparedPercentageByReducedValue() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.reduced_value)) {
        let old = this.parseToFloat(this.reduced_value) * 100;
        let cash = this.parseToFloat(this.value_cash) * 100;
        let spare = (cash - old);
        let percentual = (spare / cash) * 100;
        this.spared_percent = (isNaN(percentual)) ? this.cleanValue(0) : this.cleanValue(percentual);
        this.spare_inline = this.spared_percent;
      }
    },
    calculateValueSum() {
      if (!!this.value_cash && !!this.value_old) {
        let old = this.parseToFloat(this.value_old);
        let cash = this.parseToFloat(this.value_cash);
        this.value_sum = this.cleanValue(cash + old);
      }
    },
    calculateValueSumByReducedValue() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.reduced_value)) {
        let old = this.parseToFloat(this.reduced_value);
        let cash = this.parseToFloat(this.value_cash);
        this.value_sum = this.cleanValue(cash + old);
      }
    },
    calculateValueDivided() {
      if (!!this.value_cash && !!this.value_old) {
        let old = this.parseToFloat(this.value_old);
        let cash = this.parseToFloat(this.value_cash);
        this.value_divided = this.cleanValue((cash + old) / 2);
      }
    },
    calculatePromotionalProductValue() {
      if (this.isNotUndefinedOrEmpty(this.quantity) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let valueOld = this.parseToFloat(this.value_old);
        let quantity = this.parseToFloat(this.quantity);
        this.promotional_product_value = this.cleanValue(valueOld * quantity);
      }
    },
    calculatePromotionalProductValueWithQuantityFractional() {
      if (this.isNotUndefinedOrEmpty(this.quantity_fractional) && this.isNotUndefinedOrEmpty(this.value_old)) {
        let valueOld = this.parseToFloat(this.value_old);
        let quantity = this.quantity_fractional;
        this.promotional_product_value = this.cleanValue(valueOld * quantity);
      }
    },
    calculateValueDividedByReducedValue() {
      if (this.isNotUndefinedOrEmpty(this.value_cash) && this.isNotUndefinedOrEmpty(this.reduced_value)) {
        let old = this.parseToFloat(this.reduced_value);
        let cash = this.parseToFloat(this.value_cash);
        this.value_divided = this.cleanValue((cash + old) / 2);
      }
    },
    calculateValuePlot() {
      if ((this.isNotUndefinedOrEmpty(this.value_cash) ||
              (this.isNotUndefinedOrEmpty(this.value_old) || this.isNotUndefinedOrEmpty(this.reduced_value))) &&
          this.isNotUndefinedOrEmpty(this.parcel)) {

        let value = this.parseToFloat(this.value_cash);

        if (this.inArray('value_old') || this.inArray('value_old_inline')) {
          if (this.inArray('value_old') && this.isNotUndefinedOrEmpty(this.value_old)) {
            value = this.parseToFloat(this.value_old);
          }
        }

        if (this.inArray('reduced_value') && this.checkIsInPoster('reduced_value')) {
          if (this.inArray('reduced_value') && this.isNotUndefinedOrEmpty(this.reduced_value)) {
            value = this.parseToFloat(this.reduced_value);
          }
        }

        let parcel = parseInt(this.parcel);

        parcel = (parcel == 0) ? 1 : parcel;
        if (this.subDomain == 'magazineluiza') {
          let campaignId = this.$store.getters['selector/getCampaignId'];
          RateService.fetchPaymentTypes(parcel, campaignId).then((types) => {
            this.payment_types = types;
          });
        } else {
          RateService.fetchPaymentTypes().then((types) => {
            this.payment_types = _.values(types);
          });
        }
        let valuePlot = value / parcel;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          valuePlot = Math.ceil(valuePlot * 100) / 100;
        }
        if (this.payment_type)
          this.condition = this.payment_type;
        this.value_plot = this.cleanValue(valuePlot);
      }
    },
    calculateExclusiveValuePlot() {
      if (this.isNotUndefinedOrEmpty(this.exclusive_value_cash) && this.isNotUndefinedOrEmpty(this.exclusive_parcel)) {
        let value = this.parseToFloat(this.exclusive_value_cash);
        let parcel = parseInt(this.exclusive_parcel);
        parcel = (parcel == 0) ? 1 : parcel;
        let valuePlotSeparated = value / parcel;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          valuePlotSeparated = Math.ceil(valuePlotSeparated * 100) / 100;
        }
        this.exclusive_value_plot = this.cleanValue(valuePlotSeparated);
      }
    },
    calculateExclusiveValuePlot2() {
      if (this.isNotUndefinedOrEmpty(this.exclusive_value_cash_2) && this.isNotUndefinedOrEmpty(this.exclusive_parcel_2)) {
        let value = this.parseToFloat(this.exclusive_value_cash_2);
        let parcel = parseInt(this.exclusive_parcel_2);
        parcel = (parcel == 0) ? 1 : parcel;
        let valuePlotSeparated = value / parcel;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          valuePlotSeparated = Math.ceil(valuePlotSeparated * 100) / 100;
        }
        this.exclusive_value_plot_2 = this.cleanValue(valuePlotSeparated);
      }
    },
    calculateValuePlotSeparated() {
      if ((this.isNotUndefinedOrEmpty(this.value_cash) ||
              (this.isNotUndefinedOrEmpty(this.value_old) || this.isNotUndefinedOrEmpty(this.reduced_value))) &&
          this.isNotUndefinedOrEmpty(this.parcel)) {
        let value = this.parseToFloat(this.value_cash);
        if (this.inArray('value_old') && this.isNotUndefinedOrEmpty(this.value_old))
          value = this.parseToFloat(this.value_old);
        if (this.inArray('reduced_value') && this.isNotUndefinedOrEmpty(this.reduced_value))
          value = this.parseToFloat(this.reduced_value);
        let parcel = parseInt(this.parcel);
        parcel = (parcel == 0) ? 1 : parcel;
        let valuePlotSeparated = value / parcel;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          valuePlotSeparated = Math.ceil(valuePlotSeparated * 100) / 100;
        }
        this.value_plot_separated = this.cleanValue(valuePlotSeparated);
      }
    },
    calculateValuePlotSeparated2() {
      if ((this.isNotUndefinedOrEmpty(this.value_cash) ||
              (this.isNotUndefinedOrEmpty(this.value_old) || this.isNotUndefinedOrEmpty(this.reduced_value))) &&
          this.isNotUndefinedOrEmpty(this.parcel_separated_2)) {
        let value = this.parseToFloat(this.value_cash);
        if (this.inArray('value_old') && this.isNotUndefinedOrEmpty(this.value_old))
          value = this.parseToFloat(this.value_old);
        if (this.inArray('reduced_value') && this.isNotUndefinedOrEmpty(this.reduced_value))
          value = this.parseToFloat(this.reduced_value);
        let parcel = parseInt(this.parcel_separated_2);
        parcel = (parcel == 0) ? 1 : parcel;
        let valuePlotSeparated = value / parcel;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          valuePlotSeparated = Math.ceil(valuePlotSeparated * 100) / 100;
        }

        this.value_plot_separated_2 = this.cleanValue(valuePlotSeparated);
      }
    },
    calculateTotalTerm() {
      if (this.isNotUndefinedOrEmpty(this.value_plot) && this.isNotUndefinedOrEmpty(this.parcel)) {
        let value = this.parseToFloat(this.value_plot);
        let parcel = parseInt(this.parcel);
        this.total_term = this.cleanValue(value * parcel);
      }
    },
    calculateTotalTerm2() {
      if (this.isNotUndefinedOrEmpty(this.value_plot) && this.isNotUndefinedOrEmpty(this.parcel)) {
        let value = this.parseToFloat(this.value_plot);
        let parcel = parseInt(this.parcel);
        this.total_term_2 = this.cleanValue(value * parcel);
      }
    },
    calculateValueRemaining() {
      if (this.isNotUndefinedOrEmpty(this.value_plot) && this.isNotUndefinedOrEmpty(this.total_term) &&
          this.isNotUndefinedOrEmpty(this.parcel_paid)) {
        let value = this.parseToFloat(this.value_plot);
        let total = this.parseToFloat(this.total_term);
        let parcel = parseInt(this.parcel_paid);
        let remaining = total - (value * parcel);
        remaining = (remaining > 0) ? remaining : 0;
        this.value_remaining = this.cleanValue(remaining);
      }
    },
    calculateValueRemaining2() {
      if (this.isNotUndefinedOrEmpty(this.value_plot) && this.isNotUndefinedOrEmpty(this.total_term_2) &&
          this.isNotUndefinedOrEmpty(this.parcel_paid)) {
        let value = this.parseToFloat(this.value_plot);
        let total = this.parseToFloat(this.total_term_2);
        let parcel = parseInt(this.parcel_paid);
        let remaining = total - (value * parcel);
        remaining = (remaining > 0) ? remaining : 0;
        this.value_remaining = this.cleanValue(remaining);
      }
    },
    calculateWholesaleTotal() {
      if (this.isNotUndefinedOrEmpty(this.quantity) && (this.isNotUndefinedOrEmpty(this.value_wholesale) || this.isNotUndefinedOrEmpty(this.value_wholeretail))) {
        let value = this.isNotUndefinedOrEmpty(this.value_wholeretail)
            ? this.parseToFloat(this.value_wholeretail)
            : this.parseToFloat(this.value_wholesale);

        let quantity = parseInt(this.quantity);
        let value_total_wholesale = value * quantity;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          value_total_wholesale = Math.ceil(value_total_wholesale * 100) / 100;
        }
        this.value_total_wholesale = this.cleanValue(value_total_wholesale);
      }
    },
    calculateWholesaleTotalWithQuantityFractional() {
      if (this.isNotUndefinedOrEmpty(this.quantity_fractional) && (this.isNotUndefinedOrEmpty(this.value_wholesale) || this.isNotUndefinedOrEmpty(this.value_wholeretail))) {
        let value = this.isNotUndefinedOrEmpty(this.value_wholeretail)
            ? this.parseToFloat(this.value_wholeretail)
            : this.parseToFloat(this.value_wholesale);

        let quantity = this.quantity_fractional;
        let value_total_wholesale = value * quantity;
        if (this.userPreferences.indexOf('roundToUp') !== -1) {
          value_total_wholesale = Math.ceil(value_total_wholesale * 100) / 100;
        }
        this.value_total_wholesale = this.cleanValue(value_total_wholesale);
      }
    },
    calculateTotalTermValuePlotInterest() {
      let value = this.parseToFloat(this.total_term);
      let parcel = parseInt(this.parceled_interest);
      parcel = (parcel == 0) ? 1 : parcel;
      this.value_plot_interest = this.cleanValue(value / parcel);
    },

    calculateTotalTermValuePlotInterest2() {
      let value = this.parseToFloat(this.total_term_2);
      let parcel = parseInt(this.parceled_interest_2);
      parcel = (parcel == 0) ? 1 : parcel;
      this.value_plot_interest_2 = this.cleanValue(value / parcel);
    },
    calculateValuePlotByFactor() {
      let factor;
      if (this.subDomain == 'magazineluiza') {
        this.payment_type_id = this.rate.id;
        factor = this.with_down_payment
            ? this.rate.financing_ratio_with_down_payment
            : this.rate.financing_ratio_without_down_payment;
        factor = factor ? parseFloat(factor) : 0;
      } else {
        factor = parseFloat(this.rate.factor) || 0;
      }
      let parcel = parseInt(this.parceled_interest);
      let value = this.parseToFloat(this.value_cash);
      if (this.inArray('value_old') && this.parseToFloat(this.value_old) != 0 && this.inTemplate('value_old'))
        value = this.parseToFloat(this.value_old);
      else if (this.inArray('reduced_value') && this.parseToFloat(this.reduced_value) != 0 && this.inTemplate('reduced_value'))
        value = this.parseToFloat(this.reduced_value);
      let valuePlot = 0;
      parcel = (parcel > 0) ? parcel : 1;
      if (factor > 0) {
        valuePlot = value * factor;
      } else {
        valuePlot = value / parcel;
      }

      if (this.userPreferences.indexOf('roundToUp') !== -1) {
        valuePlot = Math.ceil(valuePlot * 100) / 100;
      }

      this.value_plot_interest = this.cleanValue(valuePlot);
      if (this.inArray('total_term')) {
        this.total_term = this.cleanValue(valuePlot * parcel);
      }
    },
    calculateValuePlotByFactor2() {
      let factor;
      if (this.subDomain == 'magazineluiza') {
        this.payment_type_id = this.rate.id;
        factor = this.with_down_payment
            ? this.rate.financing_ratio_with_down_payment
            : this.rate.financing_ratio_without_down_payment;
        factor = factor ? parseFloat(factor) : 0;
      } else {
        factor = parseFloat(this.rate.factor) || 0;
      }
      let parcel = parseInt(this.parceled_interest_2);
      let value = this.parseToFloat(this.value_cash2);
      if (this.inArray('value_old2') && this.parseToFloat(this.value_old2) != 0 && this.inTemplate('value_old2'))
        value = this.parseToFloat(this.value_old2);
      else if (this.inArray('reduced_value') && this.parseToFloat(this.reduced_value) != 0 && this.inTemplate('reduced_value'))
        value = this.parseToFloat(this.reduced_value);
      let valuePlot = 0;
      parcel = (parcel > 0) ? parcel : 1;
      if (factor > 0) {
        valuePlot = value * factor;
      } else {
        valuePlot = value / parcel;
      }

      valuePlot = Math.ceil(valuePlot * 100) / 100;
      this.value_plot_interest_2 = this.cleanValue(valuePlot);
      if (this.inArray('total_term_2')) {
        this.total_term_2 = this.cleanValue(valuePlot * parcel);
      }
    },
    calculateValuePlotInterest: _.debounce(function () {
      if ((this.isNotUndefinedOrEmpty(this.value_cash)
              || (this.isNotUndefinedOrEmpty(this.value_old) || this.isNotUndefinedOrEmpty(this.reduced_value)))
          && this.isNotUndefinedOrEmpty(this.parceled_interest) && this.parceled_interest > 0) {
        let parcel = parseInt(this.parceled_interest);
        let condition = this.payment_type;
        if (condition) {
          const product = {
            id: this.productSelected.code,
            price: this.productSelected.price,
          };
          let paymentConditionId = 0;
          if (Array.isArray(this.posterState.payment_types)) {
            const paymentCondition = this.posterState.payment_types.find(item =>
                item.sheet_name === condition,
            );
            paymentConditionId = paymentCondition ? paymentCondition.id : false;
          }
          if (paymentConditionId) {
            $('.loader-search').addClass('fa fa-spinner fa-spin');
            RateService.fetchRate(parcel, condition, product, paymentConditionId).then((data) => {
              this.rate = data.rate;
              $('.loader-search').removeClass('fa fa-spinner fa-spin');
              this.calculateValuePlotByFactor();
              if (!(this.subDomain == 'magazineluiza')) {
                let rate = parseFloat(data.rate.interest) * 100;
                this.has_interest = this.cleanValue(rate);
                this.condition = data.rate.rate_name;
                let cet = parseFloat(data.rate.cet) * 100;
                this.cet = this.cleanValue(cet);
                this.cet_py = this.cleanValue(cet * 12);
                this.legal_informations = data.rate.legal_informations;
              } else {
                this.condition = condition;
                this.cet = this.cleanValue(data.rate.cet);
                this.cet_py = this.cleanValue(data.rate.cet_py);
                this.has_interest = this.cleanValue(data.rate.interest);
                let onlyParcel = this.inArray('parceled_inline');
                if (data.rate.interest == 0 && !this.isHybrid && !onlyParcel) {
                  const message = 'Este produto está sem juros! Troque a forma de pagamento.';
                  this.$root.throwFlashMessage('danger', message);
                  this.$root.$emit('magazine-change-dynamic', false);
                } else {
                  this.$root.$emit('magazine-change-dynamic', true);
                }
              }
            }).catch((error) => {
              $('.loader-search').removeClass('fa fa-spinner fa-spin');
              this.$root.throwFlashMessage('danger', error.message);
              this.value_plot_interest = 0;
              let onlyParcel = this.inArray('parceled_inline');
              if (this.subDomain == 'magazineluiza' && !this.isHybrid && !onlyParcel) {
                const message = 'Este produto está sem juros! Troque a forma de pagamento.';
                this.$root.throwFlashMessage('danger', message);
                this.$root.$emit('magazine-change-dynamic', false);
              } else {
                this.$root.$emit('magazine-change-dynamic', true);
              }
            });
          }
        }
      }
    }, 300),
    calculateValuePlotInterest2: _.debounce(function () {
      if ((this.isNotUndefinedOrEmpty(this.value_cash2)
              || (this.isNotUndefinedOrEmpty(this.value_old2) || this.isNotUndefinedOrEmpty(this.reduced_value)))
          && this.isNotUndefinedOrEmpty(this.parceled_interest_2) && this.parceled_interest_2 > 0) {
        let parcel = parseInt(this.parceled_interest_2);
        let condition = this.payment_type;
        if (condition) {
          const product = {
            id: this.productSelected.code,
            price: this.productSelected.price,
          };
          let paymentConditionId = 0;
          if (Array.isArray(this.posterState.payment_types)) {
            const paymentCondition = this.posterState.payment_types.find(item =>
                item.sheet_name === condition,
            );
            paymentConditionId = paymentCondition ? paymentCondition.id : false;
          }
          if (paymentConditionId) {
            $('.loader-search').addClass('fa fa-spinner fa-spin');
            RateService.fetchRate(parcel, condition, product, paymentConditionId).then((data) => {
              this.rate = data.rate;
              $('.loader-search').removeClass('fa fa-spinner fa-spin');
              this.calculateValuePlotByFactor2();
              if (!(this.subDomain == 'magazineluiza')) {
                let rate = parseFloat(data.rate.interest) * 100;
                this.has_interest = this.cleanValue(rate);
                this.condition = data.rate.rate_name;
                let cet = parseFloat(data.rate.cet) * 100;
                this.cet = this.cleanValue(cet);
                this.cet_py = this.cleanValue(cet * 12);
                this.legal_informations = data.rate.legal_informations;
              } else {
                this.condition = condition;
                this.cet = this.cleanValue(data.rate.cet);
                this.cet_py = this.cleanValue(data.rate.cet_py);
                this.has_interest = this.cleanValue(data.rate.interest);
                let onlyParcel = this.inArray('parceled_inline');
                if (data.rate.interest == 0 && !this.isHybrid && !onlyParcel) {
                  const message = 'Este produto está sem juros! Troque a forma de pagamento.';
                  this.$root.throwFlashMessage('danger', message);
                  this.$root.$emit('magazine-change-dynamic', false);
                } else {
                  this.$root.$emit('magazine-change-dynamic', true);
                }
              }
            }).catch((error) => {
              $('.loader-search').removeClass('fa fa-spinner fa-spin');
              this.$root.throwFlashMessage('danger', error.message);
              this.value_plot_interest_2 = 0;
              let onlyParcel = this.inArray('parceled_inline');
              if (this.subDomain == 'magazineluiza' && !this.isHybrid && !onlyParcel) {
                const message = 'Este produto está sem juros! Troque a forma de pagamento.';
                this.$root.throwFlashMessage('danger', message);
                this.$root.$emit('magazine-change-dynamic', false);
              } else {
                this.$root.$emit('magazine-change-dynamic', true);
              }
            });
          }
        }
      }
    }, 300),
    fetchPromotionalProducts: _.debounce(function (query, loading) {
      loading(true);
      ProductService.fetchProducts(query).then((products) => {
        const data = {
          products: products,
          hasSubdomain: this.subDomain == 'magazineluiza',
        };
        this.$store.commit('product/SET_PRODUCTS', data);
        loading(false);
        return products;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    }, 300),
    previewImageOnContent(payload) {
      let templateImage = this.templateImages.find((image) => image.index == payload.index);
      templateImage.preview = payload.base64;
      const image = this.setImageOnContent(templateImage, true);
      this.posterContent = $('#preview').html();
    },
    setImageOnContent(templateImage, fillContent = false) {
      let image = $(`#${templateImage.index}`);
      image[0].onload = function () {
        if (fillContent) {
          let handleImage = $(this);
          if (handleImage.height() >= handleImage.width())
            handleImage.css('width', 'auto').css('height', '100%');
          else
            handleImage.css('width', 'auto').css('height', 'auto');
        }
      };
      image.attr('src', templateImage.preview);
      return image;
    },
    clearImages() {
      this.templateImages.map((image) => {
        image.preview = '';
        this.setImageOnContent(image);
      });
      this.posterContent = $('#preview').html();
      this.$root.$emit('loadImagesAfterClearFields');
    },
    setBorderToImageContent(index) {
      const image = $(`[data-role^="${index}"]`);
      if (!!image) {
        $(image[0]).addClass('image-focused');
      }
    },
    unsetBorderToImageContent(index) {
      const image = $(`[data-role^="${index}"]`);
      if (!!image) {
        $(image[0]).removeClass('image-focused');
      }
    },
    rotateImage(event, index) {
      const degree = $(event.target).val();
      const image = $(`#${index}`);
      if (!!image) {
        image.css({WebkitTransform: 'rotate(' + degree + 'deg)'});
        image.css({'-moz-transform': 'rotate(' + degree + 'deg)'});
        this.posterContent = $('#preview').html();
      }
    },
    setRotations() {
      this.templateImages.map((image) => {
        let imageInPreview = $(`#${image.index}`);
        let hasImage = imageInPreview.attr('src');
        let degree = (hasImage) ? +(imageInPreview.attr('style').split('rotate(')[1].split('deg)')[0]) : 0;
        $(`#rotate-${image.index}`).val(degree);
      });
    },
    calculateSpareValue() {
      if (this.inArray('unitary_value')) {
        let spare = this.parseToFloat(this.unitary_value) * this.quantity - this.parseToFloat(this.value_old);
        spare = (spare >= 0) ? spare : 0;
        this.spare = this.cleanValue(spare);
      }
    },
    calculateSpareValueWithQuantityFractional() {
      if (this.inArray('unitary_value')) {
        let spare = this.parseToFloat(this.unitary_value) * this.quantity_fractional - this.parseToFloat(this.value_old);
        spare = (spare >= 0) ? spare : 0;
        this.spare = this.cleanValue(spare);
      }
    },
    calculateSpareValueByReducedValue() {
      if (this.inArray('unitary_value')) {
        let spare = this.parseToFloat(this.unitary_value) * this.quantity - this.parseToFloat(this.reduced_value);
        spare = (spare >= 0) ? spare : 0;
        this.spare = this.cleanValue(spare);
      }
    },
    calculateSpareValueByReducedValueWithQuantityFractional() {
      if (this.inArray('unitary_value')) {
        let spare = this.parseToFloat(this.unitary_value) * this.quantity_fractional - this.parseToFloat(this.reduced_value);
        spare = (spare >= 0) ? spare : 0;
        this.spare = this.cleanValue(spare);
      }
    },
    alignImage(index, places, margin = '') {
      const image = $(`[data-role="${index}"] img`);
      image.css('margin', margin);
      image.parent().css('place-items', places);
      this.posterContent = $('#preview').html();
    },
    hasError(key) {
      return this.errors.find(error => error.field === key);
    },
    addErrorsForm(key, message) {
      let error = this.hasError(key);

      if (error) {
        let keyError = this.errors.indexOf(error);
        this.errors[keyError].message = [];
        this.errors[keyError].message.push(message);

        return this.errors;
      }

      this.errors.push({field: key, message: [message]});
      return this.errors;
    },
    getMessageError(key) {
      let error = this.hasError(key);

      if (error) {
        let keyError = this.errors.indexOf(error);
        return this.errors[keyError].message;
      }

      return null;
    },
    cleanErrorsForm(key) {
      let error = this.hasError(key);

      if (error) {
        let keyError = this.errors.indexOf(error);
        this.errors.splice(keyError, 1);

        return this.errors;
      }
    },
  },
};
</script>

<style scoped>
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 15px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #354558;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #354558;
  cursor: pointer;
}
</style>

<style>
.image-focused {
  outline: 1px dashed red !important;
}

input.picker {
  padding: .75em .5em;
  font-size: 100%;
  border: 1px solid #eaeaea;
  border-width: 2px;
  width: 100%;
}

.btn-payment {
  background-color: #e0e0e0;
  border: 1px solid #e0e0e0;
  margin-bottom: 10px;
  width: 100%;
}

.btn-payment.active {
  background-color: white;
}

.down-payment {
  padding: 0;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.w-88 {
  width: 83%;
}

.top-right {
  transform: rotate(-45deg);
}

.bottom-right {
  transform: rotate(45deg);
}

.bottom-left {
  transform: rotate(45deg);
}

.top-left {
  transform: rotate(45deg);
}

.image-position-buttons {
  display: flex;
  justify-content: center;
}

.fastshop-circle {
  width: 0.2cm;
  height: 0.2cm;
  background-color: black;
  border-radius: 50%;
  position: fixed;
  left: 0.1cm;
  top: 0.1cm;
}

.fastshop-square {
  width: 0.2cm;
  height: 0.2cm;
  background-color: black;
  position: fixed;
  left: 0.1cm;
  top: 0.1cm;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Fields.vue